import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSJSON: { input: any; output: any; }
};

export type Mutation = {
  __typename?: 'Mutation';
  notifyBackendSignalChanged?: Maybe<BackendSignalChangedEvent>;
  createAnnouncement: Announcement;
  updateAnnouncement: Announcement;
  deleteAnnouncement: Announcement;
  notifyAnnouncementChanged?: Maybe<AnnouncementChangedEvent>;
  notifyAvailabilityChanged?: Maybe<AvailabilityChangedEvent>;
  createConsult?: Maybe<Consult>;
  createConsultFromData: ConsultExtended;
  deleteConsult: DeleteConsultResult;
  copyConsult: Array<CreateInsolePlansFromDataResult>;
  updateConsult?: Maybe<ConsultExtended>;
  updateConsultStatus?: Maybe<UpdateConsultStatusResult>;
  setConsultArchived?: Maybe<UpdateConsultStatusResult>;
  createUploadFilePresignedUrl: SignedUrlResult;
  createDownloadFilePresignedUrl: SignedUrlResult;
  listCustomElementFiles: Array<CustomElementFile>;
  createInsolePlan_v2: InsolePlan;
  createInsolePlanFromData: InsolePlan;
  createInsolePlansFromData: Array<CreateInsolePlansFromDataResult>;
  duplicateInsolePlan: InsolePlan;
  updateInsolePlan: InsolePlan;
  deleteInsolePlan: DeleteInsolePlanResponse;
  createOrder?: Maybe<UpdateConsultStatusResult>;
  createPrint3DJob_v2: CreatePrint3DJobResult;
  updateOrder?: Maybe<Order>;
  updateOrders: Array<Maybe<Order>>;
  notifyOrderChanged?: Maybe<OrderChangedEvent>;
  anonymizePatient?: Maybe<Patient>;
  createPatient?: Maybe<Patient>;
  updatePatient?: Maybe<Patient>;
  createScan: Scan;
  updateScan: Scan;
  replaceScanOutputs: ReplaceScanOutputsResponse;
  deleteScan: DeleteScanResponse;
  updateScanStatus?: Maybe<Order>;
  createTenant: Tenant;
  createUser: CreateUserResponse;
};


export type MutationNotifyBackendSignalChangedArgs = {
  input: NotifyBackendSignalChangedInput;
};


export type MutationCreateAnnouncementArgs = {
  input: CreateAnnouncementInput;
};


export type MutationUpdateAnnouncementArgs = {
  input: UpdateAnnouncementInput;
};


export type MutationDeleteAnnouncementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyAnnouncementChangedArgs = {
  input: NotifyAnnouncementChangedInput;
};


export type MutationNotifyAvailabilityChangedArgs = {
  input: NotifyAvailabilityChangedInput;
};


export type MutationCreateConsultArgs = {
  input?: InputMaybe<ConsultInput>;
};


export type MutationCreateConsultFromDataArgs = {
  input: ConsultExtendedInput;
};


export type MutationDeleteConsultArgs = {
  consult_id: Scalars['ID']['input'];
};


export type MutationCopyConsultArgs = {
  consult_id: Scalars['ID']['input'];
};


export type MutationUpdateConsultArgs = {
  input: ConsultExtendedInput;
};


export type MutationUpdateConsultStatusArgs = {
  input: UpdateConsultStatusInput;
};


export type MutationSetConsultArchivedArgs = {
  consult_id: Scalars['ID']['input'];
  archived: Scalars['Boolean']['input'];
};


export type MutationCreateUploadFilePresignedUrlArgs = {
  tenant_ref: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
};


export type MutationCreateDownloadFilePresignedUrlArgs = {
  key: Scalars['String']['input'];
};


export type MutationListCustomElementFilesArgs = {
  tenant_ref: Scalars['ID']['input'];
};


export type MutationCreateInsolePlan_V2Args = {
  input: CreateInsolePlanInput;
};


export type MutationCreateInsolePlanFromDataArgs = {
  input: CreateInsolePlanFromDataInput;
};


export type MutationCreateInsolePlansFromDataArgs = {
  input: Array<CreateInsolePlanFromDataInput>;
};


export type MutationDuplicateInsolePlanArgs = {
  input: DuplicateInsolePlanInput;
};


export type MutationUpdateInsolePlanArgs = {
  input: UpdateInsolePlanInput;
};


export type MutationDeleteInsolePlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


export type MutationCreatePrint3DJob_V2Args = {
  input: CreatePrint3DJobInput;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};


export type MutationUpdateOrdersArgs = {
  input: Array<UpdateOrderInput>;
};


export type MutationNotifyOrderChangedArgs = {
  input: NotifyOrderChangedInput;
};


export type MutationAnonymizePatientArgs = {
  input?: InputMaybe<AnonymizePatientInput>;
};


export type MutationCreatePatientArgs = {
  input?: InputMaybe<CreatePatientInput>;
};


export type MutationUpdatePatientArgs = {
  input?: InputMaybe<UpdatePatientInput>;
};


export type MutationCreateScanArgs = {
  input: CreateScanInput;
};


export type MutationUpdateScanArgs = {
  input: UpdateScanInput;
};


export type MutationReplaceScanOutputsArgs = {
  input: ReplaceScanOutputsInput;
};


export type MutationDeleteScanArgs = {
  scan: DeleteScanInput;
};


export type MutationCreateTenantArgs = {
  input: CreateTenantInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};

export type Query = {
  __typename?: 'Query';
  getBackendSignal?: Maybe<BackendSignal>;
  listAnnouncements: Array<Announcement>;
  getAvailabilityById?: Maybe<Availability>;
  getConsultById: ConsultExtended;
  getConsultByOrderId?: Maybe<ConsultByOrderId>;
  listConsultsByPatientId: Array<Consult>;
  listOpenConsultsByTenantId: Array<Consult>;
  listConsultOptions: Array<ConsultOption>;
  getCounterByManagerTenantId?: Maybe<Counter>;
  listCountries: Array<CountriesResponseItem>;
  getDiagnosisInfo?: Maybe<DiagnosisInfoResponse>;
  listInsoleElements: Array<InsoleElement>;
  listInsoleElementsByTenantId: Array<InsoleElement>;
  listInsoleElementIdsToHide: Array<InsoleElementIdsToHide>;
  listInsoleElementLibrariesByTenantId: Array<InsoleElementLibrary>;
  getInsolePlanById?: Maybe<InsolePlan>;
  listInsolePlansByIds: Array<InsolePlan>;
  listInsolePlansByConsultId: Array<InsolePlan>;
  listInsolePlanPreselections: Array<InsolePlanPreselection>;
  listInsolePlanOptionsByTenantId: Array<InsolePlanOption>;
  getOrderById?: Maybe<Order>;
  getOrdersByInsolePlanId: Array<Order>;
  listOrdersByWorkshopTenantId: OrdersConnection;
  listOrdersByManagerTenantId: OrdersConnection;
  listOrdersByPatientId: OrdersConnection;
  listOrdersByPatientIdAndSearchTerms: OrdersConnection;
  getPatientById?: Maybe<Patient>;
  getPatientByOrderId?: Maybe<PatientByOrderId>;
  getPatientsCountByTenantId: PatientsCount;
  listPatientsByTenantId: Array<Patient>;
  listPatientsBySearchTerms: PatientConnection;
  listPrinters3DByTenantId: Array<Printers3DItem>;
  getPrint3DLogByOrderId?: Maybe<Print3DLog>;
  listReworkReasons: Array<ReworkReason>;
  getScanById?: Maybe<Scan>;
  listScansByOrderId_v2: Array<Scan>;
  listScansByIds: Array<Scan>;
  listScansByPatientId: ScanConnection;
  listTenants: Array<Tenant>;
  listTenantParents: Array<Tenant>;
  listTenantsByWorkshopTenantId: Array<Tenant>;
  listWorkshopTenants: Array<WorkshopTenant>;
};


export type QueryGetBackendSignalArgs = {
  key: Scalars['ID']['input'];
};


export type QueryGetAvailabilityByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetConsultByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetConsultByOrderIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListConsultsByPatientIdArgs = {
  patient_id: Scalars['ID']['input'];
};


export type QueryListOpenConsultsByTenantIdArgs = {
  tenant_id: Scalars['ID']['input'];
};


export type QueryListConsultOptionsArgs = {
  language: Scalars['String']['input'];
};


export type QueryGetCounterByManagerTenantIdArgs = {
  manager_tenant_id: Scalars['ID']['input'];
  counter_type: ECounterType;
};


export type QueryListCountriesArgs = {
  language: Scalars['String']['input'];
};


export type QueryGetDiagnosisInfoArgs = {
  key: Scalars['String']['input'];
  language: Scalars['String']['input'];
};


export type QueryListInsoleElementsArgs = {
  language: Scalars['String']['input'];
};


export type QueryListInsoleElementsByTenantIdArgs = {
  tenant_id: Scalars['ID']['input'];
  language: Scalars['String']['input'];
};


export type QueryListInsoleElementLibrariesByTenantIdArgs = {
  tenant_id: Scalars['ID']['input'];
  language: Scalars['String']['input'];
};


export type QueryGetInsolePlanByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListInsolePlansByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryListInsolePlansByConsultIdArgs = {
  consult_id: Scalars['ID']['input'];
};


export type QueryListInsolePlanOptionsByTenantIdArgs = {
  tenant_id: Scalars['ID']['input'];
  language: Scalars['String']['input'];
};


export type QueryGetOrderByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrdersByInsolePlanIdArgs = {
  insole_plan_id: Scalars['ID']['input'];
};


export type QueryListOrdersByWorkshopTenantIdArgs = {
  workshop_tenant_id: Scalars['ID']['input'];
  date_from?: InputMaybe<Scalars['String']['input']>;
  date_to?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListOrdersByManagerTenantIdArgs = {
  manager_tenant_id: Scalars['ID']['input'];
  date_from?: InputMaybe<Scalars['String']['input']>;
  date_to?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListOrdersByPatientIdArgs = {
  patient_id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListOrdersByPatientIdAndSearchTermsArgs = {
  patient_id: Scalars['ID']['input'];
  search_terms?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPatientByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPatientByOrderIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPatientsCountByTenantIdArgs = {
  tenant_id: Scalars['ID']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListPatientsByTenantIdArgs = {
  tenant_id: Scalars['ID']['input'];
};


export type QueryListPatientsBySearchTermsArgs = {
  tenant_id: Scalars['ID']['input'];
  search_terms?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListPrinters3DByTenantIdArgs = {
  tenant_id: Scalars['ID']['input'];
};


export type QueryGetPrint3DLogByOrderIdArgs = {
  order_id: Scalars['ID']['input'];
};


export type QueryListReworkReasonsArgs = {
  language: Scalars['String']['input'];
};


export type QueryGetScanByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListScansByOrderId_V2Args = {
  order_id: Scalars['ID']['input'];
};


export type QueryListScansByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryListScansByPatientIdArgs = {
  patient_id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListTenantsByWorkshopTenantIdArgs = {
  workshop_tenant_id: Scalars['ID']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  onBackendSignalChanged?: Maybe<BackendSignalChangedEvent>;
  onAnnouncementChanged?: Maybe<AnnouncementChangedEvent>;
  onOrderChanged?: Maybe<OrderChangedEvent>;
  onAvailabilityChanged?: Maybe<AvailabilityChangedEvent>;
};


export type SubscriptionOnBackendSignalChangedArgs = {
  key: Scalars['ID']['input'];
};


export type SubscriptionOnOrderChangedArgs = {
  tenant_id: Scalars['ID']['input'];
};

export enum EAnnouncementAppType {
  Manager = 'MANAGER',
  Workshop = 'WORKSHOP',
  Both = 'BOTH'
}

export type AnnouncementMessages = {
  __typename?: 'AnnouncementMessages';
  nl_NL: Scalars['String']['output'];
  de_DE: Scalars['String']['output'];
  en_US: Scalars['String']['output'];
  fr_FR: Scalars['String']['output'];
  fi_FI: Scalars['String']['output'];
};

export type Announcement = {
  __typename?: 'Announcement';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  appType: EAnnouncementAppType;
  messages: AnnouncementMessages;
  start_date: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
};

export type AnnouncementChangedEvent = {
  __typename?: 'AnnouncementChangedEvent';
  id: Scalars['ID']['output'];
  event_type: Scalars['String']['output'];
};

export type AnnouncementMessagesInput = {
  nl_NL: Scalars['String']['input'];
  de_DE: Scalars['String']['input'];
  en_US: Scalars['String']['input'];
  fr_FR: Scalars['String']['input'];
  fi_FI: Scalars['String']['input'];
};

export type CreateAnnouncementInput = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  appType: EAnnouncementAppType;
  messages: AnnouncementMessagesInput;
  start_date: Scalars['String']['input'];
  end_date: Scalars['String']['input'];
};

export type UpdateAnnouncementInput = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  appType: EAnnouncementAppType;
  messages: AnnouncementMessagesInput;
  start_date: Scalars['String']['input'];
  end_date: Scalars['String']['input'];
};

export type NotifyAnnouncementChangedInput = {
  id: Scalars['ID']['input'];
  event_type: Scalars['String']['input'];
};

export enum EAvailabilityStatus {
  Online = 'ONLINE',
  Offline = 'OFFLINE',
  Migrating = 'MIGRATING',
  Rollback = 'ROLLBACK',
  Release = 'RELEASE',
  Unknown = 'UNKNOWN',
  Loading = 'LOADING',
  AllowedIp = 'ALLOWED_IP'
}

export type Availability = {
  __typename?: 'Availability';
  id: Scalars['ID']['output'];
  status: EAvailabilityStatus;
  message?: Maybe<Scalars['String']['output']>;
};

export type AvailabilityChangedEvent = {
  __typename?: 'AvailabilityChangedEvent';
  id: Scalars['ID']['output'];
  status: EAvailabilityStatus;
  event_type: Scalars['String']['output'];
};

export type NotifyAvailabilityChangedInput = {
  id: Scalars['ID']['input'];
  status: EAvailabilityStatus;
  event_type: Scalars['String']['input'];
};

export enum EProductionMethod {
  Milling = 'MILLING',
  Printing = 'PRINTING',
  Hybrid = 'HYBRID'
}

export enum ESide {
  Both = 'BOTH',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export enum EConsultOptionEntity {
  ComplaintSince = 'COMPLAINT_SINCE',
  Complaint = 'COMPLAINT',
  Diagnosis = 'DIAGNOSIS',
  DynamicAnalyse = 'DYNAMIC_ANALYSE',
  EssentialInformation = 'ESSENTIAL_INFORMATION',
  ExistingInsole = 'EXISTING_INSOLE',
  FootType = 'FOOT_TYPE',
  ForefootAngle = 'FOREFOOT_ANGLE',
  Hips = 'HIPS',
  Knees = 'KNEES',
  Mt_1Mobility = 'MT_1_MOBILITY',
  Mtp_1DorsalflexiRom = 'MTP_1_DORSALFLEXI_ROM',
  Pathologies = 'PATHOLOGIES',
  Pelvis = 'PELVIS',
  PhysicalAge = 'PHYSICAL_AGE',
  Posture = 'POSTURE',
  ReasonVisit = 'REASON_VISIT',
  Recovery = 'RECOVERY',
  ReferredVia = 'REFERRED_VIA',
  Satisfaction = 'SATISFACTION',
  SensitiveToStress = 'SENSITIVE_TO_STRESS',
  ShoeType = 'SHOE_TYPE',
  Sport = 'SPORT',
  Tibia = 'TIBIA',
  WalkRunTechnic = 'WALK_RUN_TECHNIC'
}

export enum EConsultStatus {
  Draft = 'DRAFT',
  DiagnoseDone = 'DIAGNOSE_DONE',
  FollowUpDone = 'FOLLOW_UP_DONE',
  InsolePlanCreated = 'INSOLE_PLAN_CREATED',
  Closed = 'CLOSED',
  OrderCreated = 'ORDER_CREATED'
}

export enum EFootType {
  Planus = 'PLANUS',
  Rectus = 'RECTUS',
  Cavus = 'CAVUS'
}

export type Consult = {
  __typename?: 'Consult';
  id: Scalars['ID']['output'];
  tenant_ref: Scalars['ID']['output'];
  patient_id: Scalars['ID']['output'];
  date: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
  status: EConsultStatus;
  archived?: Maybe<Scalars['Boolean']['output']>;
};

export type ConsultExtended = {
  __typename?: 'ConsultExtended';
  id: Scalars['ID']['output'];
  tenant_ref: Scalars['ID']['output'];
  patient_id: Scalars['ID']['output'];
  date: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
  status: EConsultStatus;
  archived?: Maybe<Scalars['Boolean']['output']>;
  referring_practitioner?: Maybe<Scalars['String']['output']>;
  referring_via?: Maybe<Scalars['String']['output']>;
  occupations?: Maybe<Array<ConsultOccupation>>;
  sports?: Maybe<Array<ConsultSport>>;
  hobbies?: Maybe<Array<ConsultHobby>>;
  average_pain_score?: Maybe<Scalars['Int']['output']>;
  maximum_pain_score?: Maybe<Scalars['Int']['output']>;
  vas_score?: Maybe<Scalars['Int']['output']>;
  essential_info?: Maybe<Array<ConsultEssentialInfoQuestion>>;
  essential_info_notes?: Maybe<Scalars['String']['output']>;
  reason_visit?: Maybe<Scalars['String']['output']>;
  medical_history?: Maybe<Scalars['String']['output']>;
  pathologies?: Maybe<Array<ConsultPathology>>;
  weight?: Maybe<Scalars['Int']['output']>;
  complaints?: Maybe<Array<ConsultComplaint>>;
  main_goal?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  shoes?: Maybe<Array<ConsultShoeInspection>>;
  insole_existing?: Maybe<Scalars['String']['output']>;
  insole_notes?: Maybe<Scalars['String']['output']>;
  foot_type_left?: Maybe<Scalars['String']['output']>;
  foot_type_right?: Maybe<Scalars['String']['output']>;
  pelvis_left?: Maybe<Scalars['String']['output']>;
  pelvis_right?: Maybe<Scalars['String']['output']>;
  hips_left?: Maybe<Scalars['String']['output']>;
  hips_right?: Maybe<Scalars['String']['output']>;
  knees_left?: Maybe<Scalars['String']['output']>;
  knees_right?: Maybe<Scalars['String']['output']>;
  tibia_left?: Maybe<Scalars['String']['output']>;
  tibia_right?: Maybe<Scalars['String']['output']>;
  forefoot_angle_left?: Maybe<Scalars['String']['output']>;
  forefoot_angle_right?: Maybe<Scalars['String']['output']>;
  mt1_mobility_left?: Maybe<Scalars['String']['output']>;
  mt1_mobility_right?: Maybe<Scalars['String']['output']>;
  mtp1_dorsalflexi_rom_left?: Maybe<Scalars['String']['output']>;
  mtp1_dorsalflexi_rom_right?: Maybe<Scalars['String']['output']>;
  general_inspection?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  dynamic_analyse_left?: Maybe<Scalars['String']['output']>;
  dynamic_analyse_right?: Maybe<Scalars['String']['output']>;
  dynamic_analyse_remark?: Maybe<Scalars['String']['output']>;
  walk_run_technic?: Maybe<Scalars['String']['output']>;
  kneeing_in_left?: Maybe<Scalars['Boolean']['output']>;
  kneeing_in_right?: Maybe<Scalars['Boolean']['output']>;
  trendelenburg_left?: Maybe<Scalars['Boolean']['output']>;
  trendelenburg_right?: Maybe<Scalars['Boolean']['output']>;
  squat_left?: Maybe<Scalars['Int']['output']>;
  squat_right?: Maybe<Scalars['Int']['output']>;
  one_leg_general_coordination_left?: Maybe<Scalars['Int']['output']>;
  one_leg_general_coordination_right?: Maybe<Scalars['Int']['output']>;
  one_leg_ankle_coordination_left?: Maybe<Scalars['Int']['output']>;
  one_leg_ankle_coordination_right?: Maybe<Scalars['Int']['output']>;
  one_leg_knee_coordination_left?: Maybe<Scalars['Int']['output']>;
  one_leg_knee_coordination_right?: Maybe<Scalars['Int']['output']>;
  one_leg_body_coordination_left?: Maybe<Scalars['Int']['output']>;
  one_leg_body_coordination_right?: Maybe<Scalars['Int']['output']>;
  active_assessment?: Maybe<Scalars['String']['output']>;
  passive_assessment?: Maybe<Scalars['String']['output']>;
  resistance_tests?: Maybe<Scalars['String']['output']>;
  additional_tests?: Maybe<Scalars['String']['output']>;
  sensitive_to_stress?: Maybe<Scalars['String']['output']>;
  posture?: Maybe<Scalars['String']['output']>;
  physical_age?: Maybe<Scalars['String']['output']>;
  scan_2d_templates?: Maybe<Array<Scalars['String']['output']>>;
  scan_3d_templates?: Maybe<Array<Scalars['String']['output']>>;
  scan_pp_templates?: Maybe<Array<Scalars['String']['output']>>;
  diagnosis?: Maybe<Scalars['String']['output']>;
  shoe_advise?: Maybe<Scalars['String']['output']>;
  exercises?: Maybe<Scalars['String']['output']>;
  referrals?: Maybe<Scalars['String']['output']>;
  conclusion?: Maybe<Scalars['String']['output']>;
  profile_b_diagnosis?: Maybe<Scalars['String']['output']>;
  profile_b_foot_type_left?: Maybe<EFootType>;
  profile_b_foot_type_right?: Maybe<EFootType>;
  profile_b_notes?: Maybe<Scalars['String']['output']>;
  follow_up_comments?: Maybe<Scalars['String']['output']>;
  evaluation_name?: Maybe<Scalars['String']['output']>;
  evaluation_date?: Maybe<Scalars['String']['output']>;
  follow_up_vas_score?: Maybe<Scalars['Int']['output']>;
  recovery?: Maybe<Scalars['String']['output']>;
  satisfaction?: Maybe<Scalars['String']['output']>;
  evaluation_psk_work?: Maybe<Scalars['Int']['output']>;
  evaluation_psk_sport?: Maybe<Scalars['Int']['output']>;
  evaluation_psk_hobby?: Maybe<Scalars['Int']['output']>;
  evaluation_average_pain_score?: Maybe<Scalars['Int']['output']>;
  evaluation_maximum_pain_score?: Maybe<Scalars['Int']['output']>;
  evaluation_notes?: Maybe<Scalars['String']['output']>;
  enable_reminder?: Maybe<Scalars['Boolean']['output']>;
  months_before_reminder?: Maybe<Scalars['Int']['output']>;
};

export type ConsultByOrderId = {
  __typename?: 'ConsultByOrderId';
  notes?: Maybe<Scalars['String']['output']>;
};

export type ConsultExtendedInput = {
  id: Scalars['ID']['input'];
  tenant_ref: Scalars['ID']['input'];
  patient_id: Scalars['ID']['input'];
  date: Scalars['String']['input'];
  user_id: Scalars['ID']['input'];
  status: EConsultStatus;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  referring_practitioner?: InputMaybe<Scalars['String']['input']>;
  referring_via?: InputMaybe<Scalars['String']['input']>;
  occupations?: InputMaybe<Array<ConsultOccupationInput>>;
  sports?: InputMaybe<Array<ConsultSportInput>>;
  hobbies?: InputMaybe<Array<ConsultHobbyInput>>;
  average_pain_score?: InputMaybe<Scalars['Int']['input']>;
  maximum_pain_score?: InputMaybe<Scalars['Int']['input']>;
  vas_score?: InputMaybe<Scalars['Int']['input']>;
  essential_info?: InputMaybe<Array<ConsultEssentialInfoQuestionInput>>;
  essential_info_notes?: InputMaybe<Scalars['String']['input']>;
  reason_visit?: InputMaybe<Scalars['String']['input']>;
  medical_history?: InputMaybe<Scalars['String']['input']>;
  pathologies?: InputMaybe<Array<ConsultPathologyInput>>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  complaints?: InputMaybe<Array<ConsultComplaintInput>>;
  main_goal?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  shoes?: InputMaybe<Array<ConsultShoeInspectionInput>>;
  insole_existing?: InputMaybe<Scalars['String']['input']>;
  insole_notes?: InputMaybe<Scalars['String']['input']>;
  foot_type_left?: InputMaybe<Scalars['String']['input']>;
  foot_type_right?: InputMaybe<Scalars['String']['input']>;
  pelvis_left?: InputMaybe<Scalars['String']['input']>;
  pelvis_right?: InputMaybe<Scalars['String']['input']>;
  hips_left?: InputMaybe<Scalars['String']['input']>;
  hips_right?: InputMaybe<Scalars['String']['input']>;
  knees_left?: InputMaybe<Scalars['String']['input']>;
  knees_right?: InputMaybe<Scalars['String']['input']>;
  tibia_left?: InputMaybe<Scalars['String']['input']>;
  tibia_right?: InputMaybe<Scalars['String']['input']>;
  forefoot_angle_left?: InputMaybe<Scalars['String']['input']>;
  forefoot_angle_right?: InputMaybe<Scalars['String']['input']>;
  mt1_mobility_left?: InputMaybe<Scalars['String']['input']>;
  mt1_mobility_right?: InputMaybe<Scalars['String']['input']>;
  mtp1_dorsalflexi_rom_left?: InputMaybe<Scalars['String']['input']>;
  mtp1_dorsalflexi_rom_right?: InputMaybe<Scalars['String']['input']>;
  general_inspection?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  dynamic_analyse_left?: InputMaybe<Scalars['String']['input']>;
  dynamic_analyse_right?: InputMaybe<Scalars['String']['input']>;
  dynamic_analyse_remark?: InputMaybe<Scalars['String']['input']>;
  walk_run_technic?: InputMaybe<Scalars['String']['input']>;
  kneeing_in_left?: InputMaybe<Scalars['Boolean']['input']>;
  kneeing_in_right?: InputMaybe<Scalars['Boolean']['input']>;
  trendelenburg_left?: InputMaybe<Scalars['Boolean']['input']>;
  trendelenburg_right?: InputMaybe<Scalars['Boolean']['input']>;
  squat_left?: InputMaybe<Scalars['Int']['input']>;
  squat_right?: InputMaybe<Scalars['Int']['input']>;
  one_leg_general_coordination_left?: InputMaybe<Scalars['Int']['input']>;
  one_leg_general_coordination_right?: InputMaybe<Scalars['Int']['input']>;
  one_leg_ankle_coordination_left?: InputMaybe<Scalars['Int']['input']>;
  one_leg_ankle_coordination_right?: InputMaybe<Scalars['Int']['input']>;
  one_leg_knee_coordination_left?: InputMaybe<Scalars['Int']['input']>;
  one_leg_knee_coordination_right?: InputMaybe<Scalars['Int']['input']>;
  one_leg_body_coordination_left?: InputMaybe<Scalars['Int']['input']>;
  one_leg_body_coordination_right?: InputMaybe<Scalars['Int']['input']>;
  active_assessment?: InputMaybe<Scalars['String']['input']>;
  passive_assessment?: InputMaybe<Scalars['String']['input']>;
  resistance_tests?: InputMaybe<Scalars['String']['input']>;
  additional_tests?: InputMaybe<Scalars['String']['input']>;
  sensitive_to_stress?: InputMaybe<Scalars['String']['input']>;
  posture?: InputMaybe<Scalars['String']['input']>;
  physical_age?: InputMaybe<Scalars['String']['input']>;
  scan_2d_templates?: InputMaybe<Array<Scalars['String']['input']>>;
  scan_3d_templates?: InputMaybe<Array<Scalars['String']['input']>>;
  scan_pp_templates?: InputMaybe<Array<Scalars['String']['input']>>;
  diagnosis?: InputMaybe<Scalars['String']['input']>;
  shoe_advise?: InputMaybe<Scalars['String']['input']>;
  exercises?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<Scalars['String']['input']>;
  conclusion?: InputMaybe<Scalars['String']['input']>;
  profile_b_diagnosis?: InputMaybe<Scalars['String']['input']>;
  profile_b_foot_type_left?: InputMaybe<EFootType>;
  profile_b_foot_type_right?: InputMaybe<EFootType>;
  profile_b_notes?: InputMaybe<Scalars['String']['input']>;
  follow_up_comments?: InputMaybe<Scalars['String']['input']>;
  evaluation_name?: InputMaybe<Scalars['String']['input']>;
  evaluation_date?: InputMaybe<Scalars['String']['input']>;
  follow_up_vas_score?: InputMaybe<Scalars['Int']['input']>;
  recovery?: InputMaybe<Scalars['String']['input']>;
  satisfaction?: InputMaybe<Scalars['String']['input']>;
  evaluation_psk_work?: InputMaybe<Scalars['Int']['input']>;
  evaluation_psk_sport?: InputMaybe<Scalars['Int']['input']>;
  evaluation_psk_hobby?: InputMaybe<Scalars['Int']['input']>;
  evaluation_average_pain_score?: InputMaybe<Scalars['Int']['input']>;
  evaluation_maximum_pain_score?: InputMaybe<Scalars['Int']['input']>;
  evaluation_notes?: InputMaybe<Scalars['String']['input']>;
  enable_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  months_before_reminder?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsultComplaint = {
  __typename?: 'ConsultComplaint';
  key: Scalars['String']['output'];
  since: Scalars['String']['output'];
};

export type ConsultComplaintInput = {
  key: Scalars['String']['input'];
  since: Scalars['String']['input'];
};

export type ConsultEssentialInfoQuestion = {
  __typename?: 'ConsultEssentialInfoQuestion';
  predefined_question: Scalars['String']['output'];
  checked: Scalars['Boolean']['output'];
};

export type ConsultEssentialInfoQuestionInput = {
  predefined_question: Scalars['String']['input'];
  checked: Scalars['Boolean']['input'];
};

export type ConsultHobby = {
  __typename?: 'ConsultHobby';
  key: Scalars['String']['output'];
  score: Scalars['Int']['output'];
};

export type ConsultHobbyInput = {
  key: Scalars['String']['input'];
  score: Scalars['Int']['input'];
};

export type ConsultOccupation = {
  __typename?: 'ConsultOccupation';
  key: Scalars['String']['output'];
  score: Scalars['Int']['output'];
};

export type ConsultOccupationInput = {
  key: Scalars['String']['input'];
  score: Scalars['Int']['input'];
};

export type ConsultOption = {
  __typename?: 'ConsultOption';
  key: Scalars['String']['output'];
  entity: EConsultOptionEntity;
  label: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  searchterms: Array<Scalars['String']['output']>;
};

export type ConsultPathology = {
  __typename?: 'ConsultPathology';
  key: Scalars['String']['output'];
};

export type ConsultPathologyInput = {
  key: Scalars['String']['input'];
};

export type ConsultSport = {
  __typename?: 'ConsultSport';
  key: Scalars['String']['output'];
  frequency: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type ConsultSportInput = {
  key: Scalars['String']['input'];
  frequency: Scalars['Int']['input'];
  score: Scalars['Int']['input'];
};

export type ConsultInput = {
  id: Scalars['ID']['input'];
  tenant_ref: Scalars['ID']['input'];
  patient_id: Scalars['ID']['input'];
  date: Scalars['String']['input'];
  user_id: Scalars['ID']['input'];
  status: EConsultStatus;
};

export type ConsultShoeInspection = {
  __typename?: 'ConsultShoeInspection';
  brand: Scalars['String']['output'];
  model: Scalars['String']['output'];
  size: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ConsultShoeInspectionInput = {
  brand: Scalars['String']['input'];
  model: Scalars['String']['input'];
  size: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UpdateConsultStatusInput = {
  consult_id: Scalars['ID']['input'];
  status: EOrderStatus;
};

export type UpdateConsultStatusResult = {
  __typename?: 'UpdateConsultStatusResult';
  success: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteConsultResult = {
  __typename?: 'DeleteConsultResult';
  success: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export enum ECounterType {
  Order = 'ORDER',
  Patient = 'PATIENT'
}

export type Counter = {
  __typename?: 'Counter';
  manager_tenant_id: Scalars['ID']['output'];
  counter_type: ECounterType;
  counter: Scalars['Int']['output'];
};

export type CountriesResponseItem = {
  __typename?: 'CountriesResponseItem';
  countryCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
};

export type DiagnosisInfoChapter = {
  __typename?: 'DiagnosisInfoChapter';
  heading: Scalars['String']['output'];
  content: Scalars['String']['output'];
};

export type DiagnosisInfoData = {
  __typename?: 'DiagnosisInfoData';
  title: Scalars['String']['output'];
  chapters: Array<DiagnosisInfoChapter>;
};

export type DiagnosisInfoResponse = {
  __typename?: 'DiagnosisInfoResponse';
  key: Scalars['String']['output'];
  info?: Maybe<DiagnosisInfoData>;
};

export enum ESignedUrlMethod {
  Get = 'GET',
  Put = 'PUT'
}

export type SignedUrlResult = {
  __typename?: 'SignedUrlResult';
  bucket: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  method: ESignedUrlMethod;
};

export type CustomElementFile = {
  __typename?: 'CustomElementFile';
  identifier: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  checksum: Scalars['String']['output'];
  modified_at: Scalars['String']['output'];
};

export enum EGroundSolePatternGroup {
  Gzp = 'GZP',
  Gzppz = 'GZPPZ',
  Gzppf = 'GZPPF',
  Gzpvso = 'GZPVSO',
  Gzptd = 'GZPTD'
}

export type InsoleElementLibrary = {
  __typename?: 'InsoleElementLibrary';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum EInsoleElementInfill {
  Extrahard = 'EXTRAHARD',
  Hard = 'HARD',
  Medium = 'MEDIUM',
  Soft = 'SOFT',
  Extrasoft = 'EXTRASOFT',
  Supersoft = 'SUPERSOFT'
}

export type InsoleElement = {
  __typename?: 'InsoleElement';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  height_default?: Maybe<Scalars['Float']['output']>;
  height_min?: Maybe<Scalars['Float']['output']>;
  height_max?: Maybe<Scalars['Float']['output']>;
  height_adjustable?: Maybe<Scalars['Boolean']['output']>;
  manual: Scalars['Boolean']['output'];
  library: Scalars['String']['output'];
};

export type InsoleElementIdsToHide = {
  __typename?: 'InsoleElementIdsToHide';
  id: Scalars['ID']['output'];
  ids: Array<Scalars['ID']['output']>;
};

export type InsoleMaterialsResponseItem = {
  __typename?: 'InsoleMaterialsResponseItem';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  production_method: Scalars['String']['output'];
};

export enum EInsolePlanOptionEntity {
  BottomFinish = 'BOTTOM_FINISH',
  GroundSolePattern = 'GROUND_SOLE_PATTERN',
  GroundSolePattern_3D = 'GROUND_SOLE_PATTERN_3D',
  Material = 'MATERIAL',
  Topcover = 'TOPCOVER',
  InsoleType = 'INSOLE_TYPE'
}

export enum EScanType {
  Scan_2D = 'SCAN_2D',
  Scan_3D = 'SCAN_3D'
}

export enum EFinishingBy {
  Insolution = 'INSOLUTION',
  Practitioner = 'PRACTITIONER'
}

export enum EInfill {
  ExtraHard = 'EXTRA_HARD',
  Hard = 'HARD',
  Medium = 'MEDIUM',
  Soft = 'SOFT',
  ExtraSoft = 'EXTRA_SOFT',
  SuperSoft = 'SUPER_SOFT',
  SuperSoftForefootMediumHindfoot = 'SUPER_SOFT_FOREFOOT_MEDIUM_HINDFOOT',
  ExtraSoftForefootHardHindfoot = 'EXTRA_SOFT_FOREFOOT_HARD_HINDFOOT',
  SupersoftForefootHardHindfoot = 'SUPERSOFT_FOREFOOT_HARD_HINDFOOT',
  MediumForefootSupersoftHindfoot = 'MEDIUM_FOREFOOT_SUPERSOFT_HINDFOOT'
}

export enum EShoeSizeSystem {
  Eu = 'EU',
  Uk = 'UK',
  Us = 'US'
}

export enum ETopCoverColor {
  Unknown = 'UNKNOWN',
  AirevaEvolution = 'AIREVA_EVOLUTION',
  Army = 'ARMY',
  BabyBlauw = 'BABY_BLAUW',
  BabyRoze = 'BABY_ROZE',
  Beige = 'BEIGE',
  BeigeGlad = 'BEIGE_GLAD',
  BeigePerfo = 'BEIGE_PERFO',
  BeigePpt = 'BEIGE_PPT',
  Blackblue = 'BLACKBLUE',
  Blackroze = 'BLACKROZE',
  Blauw = 'BLAUW',
  Blauwpaarswit = 'BLAUWPAARSWIT',
  BlauwPerfo = 'BLAUW_PERFO',
  Bruin = 'BRUIN',
  BruinGlad = 'BRUIN_GLAD',
  BruinPerfo = 'BRUIN_PERFO',
  BruinSpeciaal = 'BRUIN_SPECIAAL',
  ChocklessAnthracyte_3_5Mm = 'CHOCKLESS_ANTHRACYTE_3_5MM',
  ChocklessAntibacter_2Mm = 'CHOCKLESS_ANTIBACTER_2MM',
  ChocklessBleu_3_5Mm = 'CHOCKLESS_BLEU_3_5MM',
  ChocklessNoir_2Mm = 'CHOCKLESS_NOIR_2MM',
  ChocoladeBruin = 'CHOCOLADE_BRUIN',
  ChocoladeBruinPerfo = 'CHOCOLADE_BRUIN_PERFO',
  DeepNavy = 'DEEP_NAVY',
  Desert = 'DESERT',
  Donkerblauw = 'DONKERBLAUW',
  DonkerblauwPerfo = 'DONKERBLAUW_PERFO',
  Donkergroen = 'DONKERGROEN',
  EnduroNoir_2Mm = 'ENDURO_NOIR_2MM',
  EnduroPetrole_2Mm = 'ENDURO_PETROLE_2MM',
  EnduroPetrole_3Mm = 'ENDURO_PETROLE_3MM',
  EvarmyGris = 'EVARMY_GRIS',
  EvarmyRose = 'EVARMY_ROSE',
  EvarmyVert = 'EVARMY_VERT',
  EvarmyVertBleu = 'EVARMY_VERT_BLEU',
  Geel = 'GEEL',
  Grijs = 'GRIJS',
  Groen = 'GROEN',
  KobaltBlauw = 'KOBALT_BLAUW',
  LimeGroen = 'LIME_GROEN',
  MagicoverBleuMarine = 'MAGICOVER_BLEU_MARINE',
  MagicoverBronze = 'MAGICOVER_BRONZE',
  MagicoverGris = 'MAGICOVER_GRIS',
  MagicoverMarron = 'MAGICOVER_MARRON',
  MagicoverMoutarde = 'MAGICOVER_MOUTARDE',
  MagicoverNoir = 'MAGICOVER_NOIR',
  MagicoverTaupe = 'MAGICOVER_TAUPE',
  MarbleBlack = 'MARBLE_BLACK',
  MarbleBlue = 'MARBLE_BLUE',
  MarbleOrange = 'MARBLE_ORANGE',
  Mokka = 'MOKKA',
  Oranje = 'ORANJE',
  Paars = 'PAARS',
  Paarsgroen = 'PAARSGROEN',
  Paarsrozewit = 'PAARSROZEWIT',
  PelybacterPlusBrunMp = 'PELYBACTER_PLUS_BRUN_MP',
  PelybacterPlusNoirMp = 'PELYBACTER_PLUS_NOIR_MP',
  PetrolBlauw = 'PETROL_BLAUW',
  PlantaardigGelooidGlad = 'PLANTAARDIG_GELOOID_GLAD',
  PlantaardigGelooidPerfo = 'PLANTAARDIG_GELOOID_PERFO',
  PmrNoir = 'PMR_NOIR',
  PmrTerra = 'PMR_TERRA',
  PodocolorBleuOcean = 'PODOCOLOR_BLEU_OCEAN',
  PodocolorCannelle = 'PODOCOLOR_CANNELLE',
  PodocolorGrisCendre = 'PODOCOLOR_GRIS_CENDRE',
  PodocolorJauneBleuVert = 'PODOCOLOR_JAUNE_BLEU_VERT',
  PodocolorRougeNoir = 'PODOCOLOR_ROUGE_NOIR',
  PodocolorVioletNoir = 'PODOCOLOR_VIOLET_NOIR',
  Rood = 'ROOD',
  Roodrozeoranjegeel = 'ROODROZEORANJEGEEL',
  Roze = 'ROZE',
  Rozewit = 'ROZEWIT',
  RozePerfo = 'ROZE_PERFO',
  Taupe = 'TAUPE',
  TaupeGlad = 'TAUPE_GLAD',
  TaupePefo = 'TAUPE_PEFO',
  TaupePerfo = 'TAUPE_PERFO',
  Vuur = 'VUUR',
  Wit = 'WIT',
  Zeebra = 'ZEEBRA',
  Zwart = 'ZWART',
  Zwartblauwgroen = 'ZWARTBLAUWGROEN',
  Zwartgeelgrijs = 'ZWARTGEELGRIJS',
  Zwartgeellime = 'ZWARTGEELLIME',
  Zwartwit = 'ZWARTWIT',
  Zwartwitpaars = 'ZWARTWITPAARS',
  ZwartGlad = 'ZWART_GLAD',
  ZwartPerfo = 'ZWART_PERFO',
  ZwartPpt = 'ZWART_PPT'
}

export type InsolePlan = {
  __typename?: 'InsolePlan';
  consult_id: Scalars['ID']['output'];
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  manager_tenant_id: Scalars['ID']['output'];
  manager_tenant_ref: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  patient_id: Scalars['ID']['output'];
  user_id: Scalars['ID']['output'];
  workshop_tenant_ref?: Maybe<Scalars['ID']['output']>;
  elements?: Maybe<Array<InsolePlanElement>>;
  patched_insole_elements?: Maybe<Array<PatchedInsoleElement>>;
  insole_type?: Maybe<Scalars['String']['output']>;
  modelling_required?: Maybe<Scalars['Boolean']['output']>;
  ground_sole_pattern?: Maybe<Scalars['String']['output']>;
  scan_type?: Maybe<EScanType>;
  production_method?: Maybe<EProductionMethod>;
  side?: Maybe<ESide>;
  size?: Maybe<Scalars['Float']['output']>;
  size_system?: Maybe<EShoeSizeSystem>;
  cad_model?: Maybe<Scalars['String']['output']>;
  cad_snapshot?: Maybe<Scalars['String']['output']>;
  production_notes?: Maybe<Scalars['String']['output']>;
  personal_notes?: Maybe<Scalars['String']['output']>;
  insole_height?: Maybe<Scalars['Float']['output']>;
  core_material?: Maybe<Scalars['String']['output']>;
  finishing_by?: Maybe<EFinishingBy>;
  infill?: Maybe<EInfill>;
  workshop?: Maybe<Scalars['String']['output']>;
  bottom_finish?: Maybe<Scalars['String']['output']>;
  top_cover_material?: Maybe<Scalars['String']['output']>;
  top_cover_color?: Maybe<ETopCoverColor>;
  deliver_top_cover_material_separately?: Maybe<Scalars['Boolean']['output']>;
  ground_sole_thickness_left?: Maybe<Scalars['Float']['output']>;
  ground_sole_thickness_right?: Maybe<Scalars['Float']['output']>;
  heel_lift_left?: Maybe<Scalars['Float']['output']>;
  heel_lift_right?: Maybe<Scalars['Float']['output']>;
  hind_foot_left?: Maybe<Scalars['Float']['output']>;
  hind_foot_right?: Maybe<Scalars['Float']['output']>;
  middle_hind_foot_left?: Maybe<Scalars['Float']['output']>;
  middle_hind_foot_right?: Maybe<Scalars['Float']['output']>;
  sole_lateral_rotation_left?: Maybe<Scalars['Float']['output']>;
  sole_lateral_rotation_right?: Maybe<Scalars['Float']['output']>;
  sole_medial_rotation_left?: Maybe<Scalars['Float']['output']>;
  sole_medial_rotation_right?: Maybe<Scalars['Float']['output']>;
  rear_foot_lateral_rotation_left?: Maybe<Scalars['Float']['output']>;
  rear_foot_lateral_rotation_right?: Maybe<Scalars['Float']['output']>;
  rear_foot_medial_rotation_left?: Maybe<Scalars['Float']['output']>;
  rear_foot_medial_rotation_right?: Maybe<Scalars['Float']['output']>;
  fore_foot_lateral_rotation_left?: Maybe<Scalars['Float']['output']>;
  fore_foot_lateral_rotation_right?: Maybe<Scalars['Float']['output']>;
  fore_foot_medial_rotation_left?: Maybe<Scalars['Float']['output']>;
  fore_foot_medial_rotation_right?: Maybe<Scalars['Float']['output']>;
};

export type InsolePlanElement = {
  __typename?: 'InsolePlanElement';
  id: Scalars['ID']['output'];
  deliver_separately?: Maybe<Scalars['Boolean']['output']>;
  left: Scalars['Boolean']['output'];
  right: Scalars['Boolean']['output'];
  height_left?: Maybe<Scalars['Float']['output']>;
  height_right?: Maybe<Scalars['Float']['output']>;
  infill_left?: Maybe<EInsoleElementInfill>;
  infill_right?: Maybe<EInsoleElementInfill>;
  rhino_id_left?: Maybe<Scalars['String']['output']>;
  rhino_id_right?: Maybe<Scalars['String']['output']>;
};

export type PatchedInsoleElement = {
  __typename?: 'PatchedInsoleElement';
  library: Scalars['String']['output'];
  name: Scalars['String']['output'];
  infill?: Maybe<Scalars['String']['output']>;
  thickness: Scalars['Float']['output'];
  side: Scalars['String']['output'];
  rhino_id?: Maybe<Scalars['String']['output']>;
};

export type InsolePlanOption = {
  __typename?: 'InsolePlanOption';
  key: Scalars['String']['output'];
  entity: EInsolePlanOptionEntity;
  label: Scalars['String']['output'];
  production_methods?: Maybe<Array<Maybe<EProductionMethod>>>;
  rank: Scalars['Int']['output'];
  shoe_size_max?: Maybe<Scalars['Float']['output']>;
  shoe_size_min?: Maybe<Scalars['Float']['output']>;
  shoe_size_system?: Maybe<EShoeSizeSystem>;
  top_cover_colors?: Maybe<Array<ETopCoverColor>>;
};

export type CreateInsolePlanInput = {
  consult_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  manager_tenant_id: Scalars['ID']['input'];
  manager_tenant_ref: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  patient_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
  fore_foot_lateral_rotation_left: Scalars['Float']['input'];
  fore_foot_lateral_rotation_right: Scalars['Float']['input'];
  fore_foot_medial_rotation_left: Scalars['Float']['input'];
  fore_foot_medial_rotation_right: Scalars['Float']['input'];
  ground_sole_thickness_left: Scalars['Float']['input'];
  ground_sole_thickness_right: Scalars['Float']['input'];
  heel_lift_left: Scalars['Float']['input'];
  heel_lift_right: Scalars['Float']['input'];
  hind_foot_left: Scalars['Float']['input'];
  hind_foot_right: Scalars['Float']['input'];
  middle_hind_foot_left: Scalars['Float']['input'];
  middle_hind_foot_right: Scalars['Float']['input'];
  rear_foot_lateral_rotation_left: Scalars['Float']['input'];
  rear_foot_lateral_rotation_right: Scalars['Float']['input'];
  rear_foot_medial_rotation_left: Scalars['Float']['input'];
  rear_foot_medial_rotation_right: Scalars['Float']['input'];
  sole_lateral_rotation_left: Scalars['Float']['input'];
  sole_lateral_rotation_right: Scalars['Float']['input'];
  sole_medial_rotation_left: Scalars['Float']['input'];
  sole_medial_rotation_right: Scalars['Float']['input'];
};

export type UpdateInsolePlanInput = {
  consult_id: Scalars['ID']['input'];
  created_at: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  manager_tenant_id: Scalars['ID']['input'];
  manager_tenant_ref: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  patient_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
  workshop_tenant_ref: Scalars['ID']['input'];
  elements?: InputMaybe<Array<InsolePlanElementInput>>;
  patched_insole_elements?: InputMaybe<Array<PatchedInsoleElementInput>>;
  insole_type?: InputMaybe<Scalars['String']['input']>;
  modelling_required?: InputMaybe<Scalars['Boolean']['input']>;
  ground_sole_pattern?: InputMaybe<Scalars['String']['input']>;
  scan_type?: InputMaybe<EScanType>;
  production_method?: InputMaybe<EProductionMethod>;
  side?: InputMaybe<ESide>;
  size?: InputMaybe<Scalars['Float']['input']>;
  size_system?: InputMaybe<EShoeSizeSystem>;
  cad_model?: InputMaybe<Scalars['String']['input']>;
  cad_snapshot?: InputMaybe<Scalars['String']['input']>;
  production_notes?: InputMaybe<Scalars['String']['input']>;
  personal_notes?: InputMaybe<Scalars['String']['input']>;
  insole_height?: InputMaybe<Scalars['Float']['input']>;
  core_material?: InputMaybe<Scalars['String']['input']>;
  finishing_by?: InputMaybe<EFinishingBy>;
  infill?: InputMaybe<EInfill>;
  workshop?: InputMaybe<Scalars['String']['input']>;
  bottom_finish?: InputMaybe<Scalars['String']['input']>;
  top_cover_material?: InputMaybe<Scalars['String']['input']>;
  top_cover_color?: InputMaybe<ETopCoverColor>;
  deliver_top_cover_material_separately?: InputMaybe<Scalars['Boolean']['input']>;
  ground_sole_thickness_left?: InputMaybe<Scalars['Float']['input']>;
  ground_sole_thickness_right?: InputMaybe<Scalars['Float']['input']>;
  heel_lift_left?: InputMaybe<Scalars['Float']['input']>;
  heel_lift_right?: InputMaybe<Scalars['Float']['input']>;
  hind_foot_left?: InputMaybe<Scalars['Float']['input']>;
  hind_foot_right?: InputMaybe<Scalars['Float']['input']>;
  middle_hind_foot_left?: InputMaybe<Scalars['Float']['input']>;
  middle_hind_foot_right?: InputMaybe<Scalars['Float']['input']>;
  sole_lateral_rotation_left?: InputMaybe<Scalars['Float']['input']>;
  sole_lateral_rotation_right?: InputMaybe<Scalars['Float']['input']>;
  sole_medial_rotation_left?: InputMaybe<Scalars['Float']['input']>;
  sole_medial_rotation_right?: InputMaybe<Scalars['Float']['input']>;
  rear_foot_lateral_rotation_left?: InputMaybe<Scalars['Float']['input']>;
  rear_foot_lateral_rotation_right?: InputMaybe<Scalars['Float']['input']>;
  rear_foot_medial_rotation_left?: InputMaybe<Scalars['Float']['input']>;
  rear_foot_medial_rotation_right?: InputMaybe<Scalars['Float']['input']>;
  fore_foot_lateral_rotation_left?: InputMaybe<Scalars['Float']['input']>;
  fore_foot_lateral_rotation_right?: InputMaybe<Scalars['Float']['input']>;
  fore_foot_medial_rotation_left?: InputMaybe<Scalars['Float']['input']>;
  fore_foot_medial_rotation_right?: InputMaybe<Scalars['Float']['input']>;
};

export type InsolePlanElementInput = {
  deliver_separately?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  left: Scalars['Boolean']['input'];
  right: Scalars['Boolean']['input'];
  height_left?: InputMaybe<Scalars['Float']['input']>;
  height_right?: InputMaybe<Scalars['Float']['input']>;
  infill_left?: InputMaybe<EInsoleElementInfill>;
  infill_right?: InputMaybe<EInsoleElementInfill>;
  rhino_id_left?: InputMaybe<Scalars['String']['input']>;
  rhino_id_right?: InputMaybe<Scalars['String']['input']>;
};

export type PatchedInsoleElementInput = {
  library: Scalars['String']['input'];
  name: Scalars['String']['input'];
  infill?: InputMaybe<Scalars['String']['input']>;
  thickness: Scalars['Float']['input'];
  side: Scalars['String']['input'];
  rhino_id?: InputMaybe<Scalars['String']['input']>;
};

export type DuplicateInsolePlanInput = {
  insole_plan_id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateInsolePlanFromDataInput = {
  consult_id: Scalars['ID']['input'];
  created_at: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  manager_tenant_id: Scalars['ID']['input'];
  manager_tenant_ref: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  patient_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
  workshop_tenant_ref: Scalars['ID']['input'];
  elements?: InputMaybe<Array<InsolePlanElementInput>>;
  patched_insole_elements?: InputMaybe<Array<PatchedInsoleElementInput>>;
  insole_type?: InputMaybe<Scalars['String']['input']>;
  modelling_required?: InputMaybe<Scalars['Boolean']['input']>;
  ground_sole_pattern?: InputMaybe<Scalars['String']['input']>;
  production_method?: InputMaybe<EProductionMethod>;
  side?: InputMaybe<ESide>;
  size?: InputMaybe<Scalars['Float']['input']>;
  cad_model?: InputMaybe<Scalars['String']['input']>;
  cad_snapshot?: InputMaybe<Scalars['String']['input']>;
  production_notes?: InputMaybe<Scalars['String']['input']>;
  personal_notes?: InputMaybe<Scalars['String']['input']>;
  insole_height?: InputMaybe<Scalars['Float']['input']>;
  core_material?: InputMaybe<Scalars['String']['input']>;
  finishing_by?: InputMaybe<EFinishingBy>;
  infill?: InputMaybe<EInfill>;
  workshop?: InputMaybe<Scalars['String']['input']>;
  bottom_finish?: InputMaybe<Scalars['String']['input']>;
  top_cover_material?: InputMaybe<Scalars['String']['input']>;
  top_cover_color?: InputMaybe<ETopCoverColor>;
  deliver_top_cover_material_separately?: InputMaybe<Scalars['Boolean']['input']>;
  ground_sole_thickness_left?: InputMaybe<Scalars['Float']['input']>;
  ground_sole_thickness_right?: InputMaybe<Scalars['Float']['input']>;
  heel_lift_left?: InputMaybe<Scalars['Float']['input']>;
  heel_lift_right?: InputMaybe<Scalars['Float']['input']>;
  hind_foot_left?: InputMaybe<Scalars['Float']['input']>;
  hind_foot_right?: InputMaybe<Scalars['Float']['input']>;
  middle_hind_foot_left?: InputMaybe<Scalars['Float']['input']>;
  middle_hind_foot_right?: InputMaybe<Scalars['Float']['input']>;
  sole_lateral_rotation_left?: InputMaybe<Scalars['Float']['input']>;
  sole_lateral_rotation_right?: InputMaybe<Scalars['Float']['input']>;
  sole_medial_rotation_left?: InputMaybe<Scalars['Float']['input']>;
  sole_medial_rotation_right?: InputMaybe<Scalars['Float']['input']>;
  rear_foot_lateral_rotation_left?: InputMaybe<Scalars['Float']['input']>;
  rear_foot_lateral_rotation_right?: InputMaybe<Scalars['Float']['input']>;
  rear_foot_medial_rotation_left?: InputMaybe<Scalars['Float']['input']>;
  rear_foot_medial_rotation_right?: InputMaybe<Scalars['Float']['input']>;
  fore_foot_lateral_rotation_left?: InputMaybe<Scalars['Float']['input']>;
  fore_foot_lateral_rotation_right?: InputMaybe<Scalars['Float']['input']>;
  fore_foot_medial_rotation_left?: InputMaybe<Scalars['Float']['input']>;
  fore_foot_medial_rotation_right?: InputMaybe<Scalars['Float']['input']>;
};

export type DeleteInsolePlanResponse = {
  __typename?: 'DeleteInsolePlanResponse';
  id: Scalars['ID']['output'];
};

export type InsolePlanPreselection = {
  __typename?: 'InsolePlanPreselection';
  id: Scalars['ID']['output'];
  diagnosis?: Maybe<Scalars['String']['output']>;
  foot_type?: Maybe<Scalars['String']['output']>;
  insole_type?: Maybe<Scalars['String']['output']>;
  element_ids: Array<Scalars['ID']['output']>;
  heel_lift: Scalars['Float']['output'];
  hind_foot: Scalars['Float']['output'];
  middle_hind_foot: Scalars['Float']['output'];
  rear_foot_lateral_rotation: Scalars['Float']['output'];
  rear_foot_medial_rotation: Scalars['Float']['output'];
  fore_foot_lateral_rotation: Scalars['Float']['output'];
  fore_foot_medial_rotation: Scalars['Float']['output'];
  ground_sole_thickness: Scalars['Float']['output'];
  sole_lateral_rotation: Scalars['Float']['output'];
  sole_medial_rotation: Scalars['Float']['output'];
};

export type CreateInsolePlansFromDataResult = {
  __typename?: 'CreateInsolePlansFromDataResult';
  insole_plan_id: Scalars['ID']['output'];
  consult_id: Scalars['ID']['output'];
};

export type InsoleTopcoversResponseItem = {
  __typename?: 'InsoleTopcoversResponseItem';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  img_url?: Maybe<Scalars['String']['output']>;
};

export enum EOrderStatus {
  New = 'NEW',
  AdditionalInformationNeeded = 'ADDITIONAL_INFORMATION_NEEDED',
  NeedsModelling = 'NEEDS_MODELLING',
  InProduction = 'IN_PRODUCTION',
  ManualFinishing = 'MANUAL_FINISHING',
  ToBeChecked = 'TO_BE_CHECKED',
  Checked = 'CHECKED',
  ReadyToShip = 'READY_TO_SHIP',
  Rework = 'REWORK',
  Cancelled = 'CANCELLED',
  Shipped = 'SHIPPED'
}

export enum EManagerOrderStatus {
  New = 'NEW',
  AdditionalInformationNeeded = 'ADDITIONAL_INFORMATION_NEEDED',
  InProduction = 'IN_PRODUCTION',
  ToBeChecked = 'TO_BE_CHECKED',
  Cancelled = 'CANCELLED',
  Shipped = 'SHIPPED'
}

export enum EShippingTarget {
  Patient = 'PATIENT',
  Tenant = 'TENANT'
}

export type Order = {
  __typename?: 'Order';
  attachments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  confirmed_at?: Maybe<Scalars['String']['output']>;
  consult_id: Scalars['ID']['output'];
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_urgent?: Maybe<Scalars['Boolean']['output']>;
  insole_plan_id: Scalars['ID']['output'];
  manager_tenant_id: Scalars['ID']['output'];
  manager_tenant_name: Scalars['String']['output'];
  manager_tenant_ref: Scalars['String']['output'];
  manager_user_id: Scalars['ID']['output'];
  material?: Maybe<Scalars['String']['output']>;
  order_number: Scalars['String']['output'];
  patient_date_of_birth?: Maybe<Scalars['String']['output']>;
  patient_id: Scalars['String']['output'];
  patient_name?: Maybe<Scalars['String']['output']>;
  production_method: EProductionMethod;
  rework_reason?: Maybe<Scalars['String']['output']>;
  scan_2d_templates?: Maybe<Array<Scalars['String']['output']>>;
  scan_3d_templates?: Maybe<Array<Scalars['String']['output']>>;
  scan_pp_templates?: Maybe<Array<Scalars['String']['output']>>;
  search_terms: Scalars['String']['output'];
  shipped_at?: Maybe<Scalars['String']['output']>;
  shipping_target: EShippingTarget;
  status: EOrderStatus;
  workshop_tenant_id: Scalars['ID']['output'];
  workshop_tenant_ref: Scalars['String']['output'];
  version_number: Scalars['Int']['output'];
  change_log?: Maybe<Array<OrderChange>>;
  last_modified_at?: Maybe<Scalars['String']['output']>;
};

export type OrderChange = {
  __typename?: 'OrderChange';
  changed_at: Scalars['String']['output'];
  change: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
};

export type OrdersConnection = {
  __typename?: 'OrdersConnection';
  items: Array<Order>;
  nextToken?: Maybe<Scalars['String']['output']>;
  date_from?: Maybe<Scalars['String']['output']>;
  date_to?: Maybe<Scalars['String']['output']>;
};

export type CreateOrderInput = {
  id: Scalars['ID']['input'];
  consult_id: Scalars['ID']['input'];
  insole_plan_id: Scalars['ID']['input'];
  order_number?: InputMaybe<Scalars['String']['input']>;
  manager_tenant_id: Scalars['ID']['input'];
  manager_tenant_name: Scalars['String']['input'];
  manager_tenant_ref: Scalars['String']['input'];
  manager_user_id: Scalars['ID']['input'];
  status: EOrderStatus;
  workshop_tenant_id: Scalars['ID']['input'];
  workshop_tenant_ref: Scalars['String']['input'];
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  material?: InputMaybe<Scalars['String']['input']>;
  production_method: EProductionMethod;
  version_number: Scalars['Int']['input'];
  patient_id: Scalars['ID']['input'];
  patient_name?: InputMaybe<Scalars['String']['input']>;
  patient_date_of_birth?: InputMaybe<Scalars['String']['input']>;
  is_urgent?: InputMaybe<Scalars['Boolean']['input']>;
  shipping_target: EShippingTarget;
  confirmed_at?: InputMaybe<Scalars['String']['input']>;
  scan_2d_templates?: InputMaybe<Array<Scalars['String']['input']>>;
  scan_3d_templates?: InputMaybe<Array<Scalars['String']['input']>>;
  scan_pp_templates?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrderChangedEvent = {
  __typename?: 'OrderChangedEvent';
  id: Scalars['ID']['output'];
  status: EOrderStatus;
  tenant_id: Scalars['ID']['output'];
  event_type: Scalars['String']['output'];
};

export type NotifyOrderChangedInput = {
  id: Scalars['ID']['input'];
  status: EOrderStatus;
  tenant_id: Scalars['ID']['input'];
  event_type: Scalars['String']['input'];
};

export type UpdateOrderInput = {
  id: Scalars['ID']['input'];
  order_number?: InputMaybe<Scalars['String']['input']>;
  manager_user_id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<EOrderStatus>;
  material?: InputMaybe<Scalars['String']['input']>;
  production_method?: InputMaybe<EProductionMethod>;
  confirmed_at?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  manager_tenant_id?: InputMaybe<Scalars['ID']['input']>;
  workshop_tenant_id?: InputMaybe<Scalars['ID']['input']>;
  manager_tenant_ref?: InputMaybe<Scalars['ID']['input']>;
  workshop_tenant_ref?: InputMaybe<Scalars['ID']['input']>;
  search_terms?: InputMaybe<Scalars['String']['input']>;
  shipped_at?: InputMaybe<Scalars['String']['input']>;
  version_number?: InputMaybe<Scalars['Int']['input']>;
  consult_id?: InputMaybe<Scalars['ID']['input']>;
  insole_plan_id?: InputMaybe<Scalars['ID']['input']>;
  patient_name?: InputMaybe<Scalars['String']['input']>;
  patient_date_of_birth?: InputMaybe<Scalars['String']['input']>;
  shipping_target?: InputMaybe<EShippingTarget>;
  is_urgent?: InputMaybe<Scalars['Boolean']['input']>;
  rework_reason?: InputMaybe<Scalars['String']['input']>;
};

export enum EPatientGender {
  Male = 'MALE',
  Female = 'FEMALE',
  Other = 'OTHER',
  Unknown = 'UNKNOWN'
}

export enum EPatientIdType {
  Passport = 'PASSPORT',
  IdCard = 'ID_CARD',
  DriverLicense = 'DRIVER_LICENSE',
  ResidencePermit = 'RESIDENCE_PERMIT',
  InsuranceCard = 'INSURANCE_CARD',
  Other = 'OTHER'
}

export enum EPatientStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Anonymized = 'ANONYMIZED'
}

export enum EPatientTitle {
  Mr = 'MR',
  Ms = 'MS',
  Miss = 'MISS',
  Mx = 'MX',
  Dr = 'DR',
  Prof = 'PROF',
  Other = 'OTHER'
}

export type AnonymizePatientInput = {
  id: Scalars['ID']['input'];
};

export type Patient = {
  __typename?: 'Patient';
  id: Scalars['ID']['output'];
  patient_number: Scalars['String']['output'];
  tenant_ref: Scalars['ID']['output'];
  tenant_id: Scalars['ID']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  last_name: Scalars['String']['output'];
  salutation?: Maybe<Scalars['String']['output']>;
  title?: Maybe<EPatientTitle>;
  initials?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  house_number?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  date_of_birth: Scalars['String']['output'];
  status?: Maybe<EPatientStatus>;
  gender?: Maybe<EPatientGender>;
  notes?: Maybe<Scalars['String']['output']>;
  bsn_number?: Maybe<Scalars['String']['output']>;
  id_type?: Maybe<EPatientIdType>;
  id_number?: Maybe<Scalars['String']['output']>;
  health_insurer?: Maybe<Scalars['String']['output']>;
  health_insurance_number?: Maybe<Scalars['String']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  search_terms?: Maybe<Scalars['String']['output']>;
  anonymized_at?: Maybe<Scalars['String']['output']>;
  anonymized_by?: Maybe<Scalars['String']['output']>;
};

export type PatientByOrderId = {
  __typename?: 'PatientByOrderId';
  id: Scalars['ID']['output'];
  patient_number: Scalars['String']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  last_name: Scalars['String']['output'];
  salutation?: Maybe<Scalars['String']['output']>;
  title?: Maybe<EPatientTitle>;
  initials?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  house_number?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
};

export type PatientConnection = {
  __typename?: 'PatientConnection';
  items: Array<Patient>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type CreatePatientInput = {
  id: Scalars['ID']['input'];
  patient_number?: InputMaybe<Scalars['String']['input']>;
  tenant_ref: Scalars['ID']['input'];
  tenant_id: Scalars['ID']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  last_name: Scalars['String']['input'];
  salutation?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<EPatientTitle>;
  initials?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  house_number?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  date_of_birth: Scalars['String']['input'];
  status?: InputMaybe<EPatientStatus>;
  gender?: InputMaybe<EPatientGender>;
  notes?: InputMaybe<Scalars['String']['input']>;
  bsn_number?: InputMaybe<Scalars['String']['input']>;
  id_type?: InputMaybe<EPatientIdType>;
  id_number?: InputMaybe<Scalars['String']['input']>;
  health_insurer?: InputMaybe<Scalars['String']['input']>;
  health_insurance_number?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePatientInput = {
  id: Scalars['ID']['input'];
  patient_number: Scalars['String']['input'];
  tenant_ref: Scalars['ID']['input'];
  tenant_id: Scalars['ID']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  last_name: Scalars['String']['input'];
  salutation?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<EPatientTitle>;
  initials?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  house_number?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  date_of_birth: Scalars['String']['input'];
  status?: InputMaybe<EPatientStatus>;
  gender?: InputMaybe<EPatientGender>;
  notes?: InputMaybe<Scalars['String']['input']>;
  bsn_number?: InputMaybe<Scalars['String']['input']>;
  id_type?: InputMaybe<EPatientIdType>;
  id_number?: InputMaybe<Scalars['String']['input']>;
  health_insurer?: InputMaybe<Scalars['String']['input']>;
  health_insurance_number?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
};

export type PatientsCount = {
  __typename?: 'PatientsCount';
  count: Scalars['Int']['output'];
  nextToken?: Maybe<Scalars['String']['output']>;
};

export enum EPrintStatus {
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type Printers3DItem = {
  __typename?: 'Printers3DItem';
  id: Scalars['ID']['output'];
  tenant_id: Scalars['ID']['output'];
  tenant_ref: Scalars['String']['output'];
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  printer_slug: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
};

export type CreatePrint3DJobInput = {
  order_id: Scalars['ID']['input'];
  insole_plan_id: Scalars['ID']['input'];
  printer_id: Scalars['ID']['input'];
  insole_plan_cad_json: Scalars['AWSJSON']['input'];
};

export type CreatePrint3DJobResult = {
  __typename?: 'CreatePrint3DJobResult';
  order_id: Scalars['ID']['output'];
  status: EPrintStatus;
  message_id: Scalars['String']['output'];
};

export type Print3DLog = {
  __typename?: 'Print3DLog';
  order_id: Scalars['ID']['output'];
  status: EPrintStatus;
  submitted_at?: Maybe<Scalars['String']['output']>;
  started_at?: Maybe<Scalars['String']['output']>;
  completed_at?: Maybe<Scalars['String']['output']>;
  failed_at?: Maybe<Scalars['String']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  runner_message_id?: Maybe<Scalars['String']['output']>;
  input_prefix?: Maybe<Scalars['String']['output']>;
  output_prefix?: Maybe<Scalars['String']['output']>;
  print_attempt: Scalars['Int']['output'];
  selected_printer_id?: Maybe<Scalars['ID']['output']>;
  selected_printer_name?: Maybe<Scalars['String']['output']>;
};

export type ReworkReason = {
  __typename?: 'ReworkReason';
  key: Scalars['String']['output'];
  current_status: EOrderStatus;
  label: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
};

export enum EScanDevice {
  Scanner_2D = 'SCANNER_2D',
  Scanner_3D = 'SCANNER_3D',
  PressurePlateSingleStep = 'PRESSURE_PLATE_SINGLE_STEP',
  PressurePlateMultiStep = 'PRESSURE_PLATE_MULTI_STEP',
  ExternalImport = 'EXTERNAL_IMPORT'
}

export enum EScanModality {
  Feetscan = 'FEETSCAN',
  Blueprint = 'BLUEPRINT',
  Footscan = 'FOOTSCAN',
  Foambox = 'FOAMBOX',
  GaitAnalysis = 'GAIT_ANALYSIS',
  StaticPosture = 'STATIC_POSTURE'
}

export enum EScanStatus {
  OrderCreated = 'ORDER_CREATED'
}

export type Scan = {
  __typename?: 'Scan';
  id: Scalars['ID']['output'];
  tenant_ref: Scalars['ID']['output'];
  patient_id: Scalars['ID']['output'];
  date: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
  status?: Maybe<EScanStatus>;
  device: EScanDevice;
  modality: EScanModality;
  pixels_per_inch: Scalars['Float']['output'];
  original_url_both?: Maybe<Scalars['String']['output']>;
  original_url_left?: Maybe<Scalars['String']['output']>;
  original_url_right?: Maybe<Scalars['String']['output']>;
  dicom_url_both?: Maybe<Scalars['String']['output']>;
  dicom_url_left?: Maybe<Scalars['String']['output']>;
  dicom_url_right?: Maybe<Scalars['String']['output']>;
  thumbnail_url_both?: Maybe<Scalars['String']['output']>;
  thumbnail_url_left?: Maybe<Scalars['String']['output']>;
  thumbnail_url_right?: Maybe<Scalars['String']['output']>;
  toolstate_url_both?: Maybe<Scalars['String']['output']>;
  toolstate_url_left?: Maybe<Scalars['String']['output']>;
  toolstate_url_right?: Maybe<Scalars['String']['output']>;
  cad_template_url_left?: Maybe<Scalars['String']['output']>;
  cad_template_url_right?: Maybe<Scalars['String']['output']>;
};

export type CreateScanInput = {
  id: Scalars['ID']['input'];
  tenant_ref: Scalars['ID']['input'];
  patient_id: Scalars['ID']['input'];
  date: Scalars['String']['input'];
  user_id: Scalars['ID']['input'];
  device: EScanDevice;
  modality: EScanModality;
  pixels_per_inch: Scalars['Float']['input'];
  original_url_both?: InputMaybe<Scalars['String']['input']>;
  original_url_left?: InputMaybe<Scalars['String']['input']>;
  original_url_right?: InputMaybe<Scalars['String']['input']>;
  dicom_url_both?: InputMaybe<Scalars['String']['input']>;
  dicom_url_left?: InputMaybe<Scalars['String']['input']>;
  dicom_url_right?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_both?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_left?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_right?: InputMaybe<Scalars['String']['input']>;
  toolstate_url_both?: InputMaybe<Scalars['String']['input']>;
  toolstate_url_left?: InputMaybe<Scalars['String']['input']>;
  toolstate_url_right?: InputMaybe<Scalars['String']['input']>;
  cad_template_url_left?: InputMaybe<Scalars['String']['input']>;
  cad_template_url_right?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScanInput = {
  id: Scalars['ID']['input'];
  tenant_ref: Scalars['ID']['input'];
  patient_id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  device: EScanDevice;
  modality: EScanModality;
  pixels_per_inch: Scalars['Float']['input'];
  original_url_both?: InputMaybe<Scalars['String']['input']>;
  original_url_left?: InputMaybe<Scalars['String']['input']>;
  original_url_right?: InputMaybe<Scalars['String']['input']>;
  dicom_url_both?: InputMaybe<Scalars['String']['input']>;
  dicom_url_left?: InputMaybe<Scalars['String']['input']>;
  dicom_url_right?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_both?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_left?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_right?: InputMaybe<Scalars['String']['input']>;
  toolstate_url_both?: InputMaybe<Scalars['String']['input']>;
  toolstate_url_left?: InputMaybe<Scalars['String']['input']>;
  toolstate_url_right?: InputMaybe<Scalars['String']['input']>;
  cad_template_url_left?: InputMaybe<Scalars['String']['input']>;
  cad_template_url_right?: InputMaybe<Scalars['String']['input']>;
};

export type ReplaceScanOutputReferencesInput = {
  id: Scalars['ID']['input'];
  expected_dicom_url_both?: InputMaybe<Scalars['String']['input']>;
  expected_dicom_url_left?: InputMaybe<Scalars['String']['input']>;
  expected_dicom_url_right?: InputMaybe<Scalars['String']['input']>;
  expected_thumbnail_url_both?: InputMaybe<Scalars['String']['input']>;
  expected_thumbnail_url_left?: InputMaybe<Scalars['String']['input']>;
  expected_thumbnail_url_right?: InputMaybe<Scalars['String']['input']>;
  expected_toolstate_url_both?: InputMaybe<Scalars['String']['input']>;
  expected_toolstate_url_left?: InputMaybe<Scalars['String']['input']>;
  expected_toolstate_url_right?: InputMaybe<Scalars['String']['input']>;
  expected_cad_template_url_left?: InputMaybe<Scalars['String']['input']>;
  expected_cad_template_url_right?: InputMaybe<Scalars['String']['input']>;
  dicom_url_both?: InputMaybe<Scalars['String']['input']>;
  dicom_url_left?: InputMaybe<Scalars['String']['input']>;
  dicom_url_right?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_both?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_left?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_right?: InputMaybe<Scalars['String']['input']>;
  toolstate_url_both?: InputMaybe<Scalars['String']['input']>;
  toolstate_url_left?: InputMaybe<Scalars['String']['input']>;
  toolstate_url_right?: InputMaybe<Scalars['String']['input']>;
  cad_template_url_left?: InputMaybe<Scalars['String']['input']>;
  cad_template_url_right?: InputMaybe<Scalars['String']['input']>;
};

export type ReplaceScanOutputsInput = {
  scans: Array<ReplaceScanOutputReferencesInput>;
};

export type ReplaceScanOutputsResponse = {
  __typename?: 'ReplaceScanOutputsResponse';
  scans: Array<Scan>;
};

export type ScanConnection = {
  __typename?: 'ScanConnection';
  items: Array<Scan>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type DeleteScanResponse = {
  __typename?: 'DeleteScanResponse';
  success: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteScanInput = {
  id: Scalars['ID']['input'];
  tenant_ref: Scalars['ID']['input'];
  patient_id: Scalars['ID']['input'];
  date: Scalars['String']['input'];
  user_id: Scalars['ID']['input'];
  status?: InputMaybe<EScanStatus>;
  device: EScanDevice;
  modality: EScanModality;
  pixels_per_inch: Scalars['Float']['input'];
  original_url_both?: InputMaybe<Scalars['String']['input']>;
  original_url_left?: InputMaybe<Scalars['String']['input']>;
  original_url_right?: InputMaybe<Scalars['String']['input']>;
  dicom_url_both?: InputMaybe<Scalars['String']['input']>;
  dicom_url_left?: InputMaybe<Scalars['String']['input']>;
  dicom_url_right?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_both?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_left?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_right?: InputMaybe<Scalars['String']['input']>;
  toolstate_url_both?: InputMaybe<Scalars['String']['input']>;
  toolstate_url_left?: InputMaybe<Scalars['String']['input']>;
  toolstate_url_right?: InputMaybe<Scalars['String']['input']>;
  cad_template_url_left?: InputMaybe<Scalars['String']['input']>;
  cad_template_url_right?: InputMaybe<Scalars['String']['input']>;
};

export type BackendSignal = {
  __typename?: 'BackendSignal';
  key: Scalars['ID']['output'];
  value: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

export type BackendSignalChangedEvent = {
  __typename?: 'BackendSignalChangedEvent';
  key: Scalars['ID']['output'];
  value: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
};

export type NotifyBackendSignalChangedInput = {
  key: Scalars['ID']['input'];
  value: Scalars['String']['input'];
  updated_at: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
};

export enum ETenantProfile {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D'
}

export type Tenant = {
  __typename?: 'Tenant';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  does_own_modelling?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  house_number?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insole_element_libraries?: Maybe<Array<Scalars['String']['output']>>;
  is_workshop?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  parent_id?: Maybe<Scalars['ID']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<ETenantProfile>;
  street?: Maybe<Scalars['String']['output']>;
  tenant_ref: Scalars['ID']['output'];
  workshop_printing_tenant_id?: Maybe<Scalars['ID']['output']>;
  workshop_printing_tenant_ref?: Maybe<Scalars['ID']['output']>;
  workshop_milling_tenant_name?: Maybe<Scalars['String']['output']>;
  workshop_milling_tenant_id?: Maybe<Scalars['ID']['output']>;
  workshop_milling_tenant_ref?: Maybe<Scalars['ID']['output']>;
  workshop_printing_tenant_name?: Maybe<Scalars['String']['output']>;
};

export type WorkshopTenant = {
  __typename?: 'WorkshopTenant';
  id: Scalars['ID']['output'];
  parent_id?: Maybe<Scalars['ID']['output']>;
  tenant_ref: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  street?: Maybe<Scalars['String']['output']>;
  house_number?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  is_workshop?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateTenantInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  does_own_modelling?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  house_number?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  is_workshop?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parent_id: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<ETenantProfile>;
  root_tenant_id: Scalars['ID']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
  tenant_ref: Scalars['ID']['input'];
  workshop_milling_tenant_id?: InputMaybe<Scalars['ID']['input']>;
  workshop_printing_tenant_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tenant_ref?: InputMaybe<Scalars['String']['input']>;
  isAdmin: Scalars['Boolean']['input'];
  poolType: Scalars['String']['input'];
};

export type CreateUserResponse = {
  __typename?: 'CreateUserResponse';
  success: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type AnnouncementFieldsFragment = { __typename?: 'Announcement', id: string, title: string, appType: EAnnouncementAppType, start_date: string, end_date: string, messages: { __typename?: 'AnnouncementMessages', nl_NL: string, de_DE: string, en_US: string, fr_FR: string, fi_FI: string } };

export type ListAnnouncementsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAnnouncementsQuery = { __typename?: 'Query', listAnnouncements: Array<{ __typename?: 'Announcement', id: string, title: string, appType: EAnnouncementAppType, start_date: string, end_date: string, messages: { __typename?: 'AnnouncementMessages', nl_NL: string, de_DE: string, en_US: string, fr_FR: string, fi_FI: string } }> };

export type CreateAnnouncementMutationVariables = Exact<{
  input: CreateAnnouncementInput;
}>;


export type CreateAnnouncementMutation = { __typename?: 'Mutation', createAnnouncement: { __typename?: 'Announcement', id: string, title: string, appType: EAnnouncementAppType, start_date: string, end_date: string, messages: { __typename?: 'AnnouncementMessages', nl_NL: string, de_DE: string, en_US: string, fr_FR: string, fi_FI: string } } };

export type UpdateAnnouncementMutationVariables = Exact<{
  input: UpdateAnnouncementInput;
}>;


export type UpdateAnnouncementMutation = { __typename?: 'Mutation', updateAnnouncement: { __typename?: 'Announcement', id: string, title: string, appType: EAnnouncementAppType, start_date: string, end_date: string, messages: { __typename?: 'AnnouncementMessages', nl_NL: string, de_DE: string, en_US: string, fr_FR: string, fi_FI: string } } };

export type DeleteAnnouncementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAnnouncementMutation = { __typename?: 'Mutation', deleteAnnouncement: { __typename?: 'Announcement', id: string } };

export type OnAnnouncementChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnAnnouncementChangedSubscription = { __typename?: 'Subscription', onAnnouncementChanged?: { __typename?: 'AnnouncementChangedEvent', id: string, event_type: string } | null };

export type GetAvailabilityByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAvailabilityByIdQuery = { __typename?: 'Query', getAvailabilityById?: { __typename?: 'Availability', id: string, status: EAvailabilityStatus, message?: string | null } | null };

export type OnAvailabilityChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnAvailabilityChangedSubscription = { __typename?: 'Subscription', onAvailabilityChanged?: { __typename?: 'AvailabilityChangedEvent', id: string, status: EAvailabilityStatus, event_type: string } | null };

export type GetBackendSignalQueryVariables = Exact<{
  key: Scalars['ID']['input'];
}>;


export type GetBackendSignalQuery = { __typename?: 'Query', getBackendSignal?: { __typename?: 'BackendSignal', key: string, value: string, updated_at: string } | null };

export type OnBackendSignalChangedSubscriptionVariables = Exact<{
  key: Scalars['ID']['input'];
}>;


export type OnBackendSignalChangedSubscription = { __typename?: 'Subscription', onBackendSignalChanged?: { __typename?: 'BackendSignalChangedEvent', key: string, value: string, updated_at: string, event_type: string } | null };

export type ListConsultOptionsQueryVariables = Exact<{
  language: Scalars['String']['input'];
}>;


export type ListConsultOptionsQuery = { __typename?: 'Query', listConsultOptions: Array<{ __typename?: 'ConsultOption', key: string, label: string, entity: EConsultOptionEntity, rank: number, searchterms: Array<string> }> };

export type GetConsultByOrderIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetConsultByOrderIdQuery = { __typename?: 'Query', getConsultByOrderId?: { __typename?: 'ConsultByOrderId', notes?: string | null } | null };

export type GetConsultByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetConsultByIdQuery = { __typename?: 'Query', getConsultById: { __typename?: 'ConsultExtended', id: string, tenant_ref: string, patient_id: string, date: string, user_id: string, status: EConsultStatus, archived?: boolean | null, referring_practitioner?: string | null, referring_via?: string | null, average_pain_score?: number | null, maximum_pain_score?: number | null, vas_score?: number | null, essential_info_notes?: string | null, reason_visit?: string | null, medical_history?: string | null, weight?: number | null, main_goal?: string | null, notes?: string | null, insole_existing?: string | null, insole_notes?: string | null, foot_type_left?: string | null, foot_type_right?: string | null, pelvis_left?: string | null, pelvis_right?: string | null, hips_left?: string | null, hips_right?: string | null, knees_left?: string | null, knees_right?: string | null, tibia_left?: string | null, tibia_right?: string | null, forefoot_angle_left?: string | null, forefoot_angle_right?: string | null, mt1_mobility_left?: string | null, mt1_mobility_right?: string | null, mtp1_dorsalflexi_rom_left?: string | null, mtp1_dorsalflexi_rom_right?: string | null, general_inspection?: string | null, remarks?: string | null, dynamic_analyse_left?: string | null, dynamic_analyse_right?: string | null, dynamic_analyse_remark?: string | null, walk_run_technic?: string | null, kneeing_in_left?: boolean | null, kneeing_in_right?: boolean | null, trendelenburg_left?: boolean | null, trendelenburg_right?: boolean | null, squat_left?: number | null, squat_right?: number | null, one_leg_general_coordination_left?: number | null, one_leg_general_coordination_right?: number | null, one_leg_ankle_coordination_left?: number | null, one_leg_ankle_coordination_right?: number | null, one_leg_knee_coordination_left?: number | null, one_leg_knee_coordination_right?: number | null, one_leg_body_coordination_left?: number | null, one_leg_body_coordination_right?: number | null, active_assessment?: string | null, passive_assessment?: string | null, resistance_tests?: string | null, additional_tests?: string | null, sensitive_to_stress?: string | null, posture?: string | null, physical_age?: string | null, follow_up_comments?: string | null, follow_up_vas_score?: number | null, evaluation_name?: string | null, evaluation_date?: string | null, recovery?: string | null, satisfaction?: string | null, evaluation_psk_work?: number | null, evaluation_psk_sport?: number | null, evaluation_psk_hobby?: number | null, evaluation_average_pain_score?: number | null, evaluation_maximum_pain_score?: number | null, evaluation_notes?: string | null, enable_reminder?: boolean | null, months_before_reminder?: number | null, scan_2d_templates?: Array<string> | null, scan_3d_templates?: Array<string> | null, scan_pp_templates?: Array<string> | null, diagnosis?: string | null, shoe_advise?: string | null, exercises?: string | null, referrals?: string | null, conclusion?: string | null, profile_b_diagnosis?: string | null, profile_b_foot_type_left?: EFootType | null, profile_b_foot_type_right?: EFootType | null, profile_b_notes?: string | null, occupations?: Array<{ __typename?: 'ConsultOccupation', key: string, score: number }> | null, sports?: Array<{ __typename?: 'ConsultSport', key: string, frequency: number, score: number }> | null, hobbies?: Array<{ __typename?: 'ConsultHobby', key: string, score: number }> | null, essential_info?: Array<{ __typename?: 'ConsultEssentialInfoQuestion', predefined_question: string, checked: boolean }> | null, pathologies?: Array<{ __typename?: 'ConsultPathology', key: string }> | null, complaints?: Array<{ __typename?: 'ConsultComplaint', key: string, since: string }> | null, shoes?: Array<{ __typename?: 'ConsultShoeInspection', brand: string, model: string, type: string, size: string }> | null } };

export type CreateConsultMutationVariables = Exact<{
  input: ConsultInput;
}>;


export type CreateConsultMutation = { __typename?: 'Mutation', createConsult?: { __typename?: 'Consult', id: string } | null };

export type CopyConsultMutationVariables = Exact<{
  consult_id: Scalars['ID']['input'];
}>;


export type CopyConsultMutation = { __typename?: 'Mutation', copyConsult: Array<{ __typename?: 'CreateInsolePlansFromDataResult', consult_id: string, insole_plan_id: string }> };

export type DeleteConsultMutationVariables = Exact<{
  consult_id: Scalars['ID']['input'];
}>;


export type DeleteConsultMutation = { __typename?: 'Mutation', deleteConsult: { __typename?: 'DeleteConsultResult', success: boolean, message?: string | null } };

export type SetConsultArchivedMutationVariables = Exact<{
  consult_id: Scalars['ID']['input'];
  archived: Scalars['Boolean']['input'];
}>;


export type SetConsultArchivedMutation = { __typename?: 'Mutation', setConsultArchived?: { __typename?: 'UpdateConsultStatusResult', success: boolean, message?: string | null } | null };

export type UpdateConsultMutationVariables = Exact<{
  input: ConsultExtendedInput;
}>;


export type UpdateConsultMutation = { __typename?: 'Mutation', updateConsult?: { __typename?: 'ConsultExtended', id: string, tenant_ref: string, patient_id: string, date: string, user_id: string, status: EConsultStatus, archived?: boolean | null, referring_practitioner?: string | null, referring_via?: string | null, average_pain_score?: number | null, maximum_pain_score?: number | null, vas_score?: number | null, essential_info_notes?: string | null, reason_visit?: string | null, medical_history?: string | null, weight?: number | null, main_goal?: string | null, notes?: string | null, insole_existing?: string | null, insole_notes?: string | null, foot_type_left?: string | null, foot_type_right?: string | null, pelvis_left?: string | null, pelvis_right?: string | null, hips_left?: string | null, hips_right?: string | null, knees_left?: string | null, knees_right?: string | null, tibia_left?: string | null, tibia_right?: string | null, forefoot_angle_left?: string | null, forefoot_angle_right?: string | null, mt1_mobility_left?: string | null, mt1_mobility_right?: string | null, mtp1_dorsalflexi_rom_left?: string | null, mtp1_dorsalflexi_rom_right?: string | null, general_inspection?: string | null, remarks?: string | null, dynamic_analyse_left?: string | null, dynamic_analyse_right?: string | null, dynamic_analyse_remark?: string | null, walk_run_technic?: string | null, kneeing_in_left?: boolean | null, kneeing_in_right?: boolean | null, trendelenburg_left?: boolean | null, trendelenburg_right?: boolean | null, squat_left?: number | null, squat_right?: number | null, one_leg_general_coordination_left?: number | null, one_leg_general_coordination_right?: number | null, one_leg_ankle_coordination_left?: number | null, one_leg_ankle_coordination_right?: number | null, one_leg_knee_coordination_left?: number | null, one_leg_knee_coordination_right?: number | null, one_leg_body_coordination_left?: number | null, one_leg_body_coordination_right?: number | null, active_assessment?: string | null, passive_assessment?: string | null, resistance_tests?: string | null, additional_tests?: string | null, sensitive_to_stress?: string | null, posture?: string | null, physical_age?: string | null, diagnosis?: string | null, shoe_advise?: string | null, exercises?: string | null, referrals?: string | null, conclusion?: string | null, profile_b_diagnosis?: string | null, profile_b_foot_type_left?: EFootType | null, profile_b_foot_type_right?: EFootType | null, profile_b_notes?: string | null, follow_up_comments?: string | null, follow_up_vas_score?: number | null, evaluation_name?: string | null, evaluation_date?: string | null, recovery?: string | null, satisfaction?: string | null, evaluation_psk_work?: number | null, evaluation_psk_sport?: number | null, evaluation_psk_hobby?: number | null, evaluation_average_pain_score?: number | null, evaluation_maximum_pain_score?: number | null, evaluation_notes?: string | null, enable_reminder?: boolean | null, months_before_reminder?: number | null, scan_2d_templates?: Array<string> | null, scan_3d_templates?: Array<string> | null, scan_pp_templates?: Array<string> | null, occupations?: Array<{ __typename?: 'ConsultOccupation', key: string, score: number }> | null, sports?: Array<{ __typename?: 'ConsultSport', key: string, frequency: number, score: number }> | null, hobbies?: Array<{ __typename?: 'ConsultHobby', key: string, score: number }> | null, essential_info?: Array<{ __typename?: 'ConsultEssentialInfoQuestion', predefined_question: string, checked: boolean }> | null, pathologies?: Array<{ __typename?: 'ConsultPathology', key: string }> | null, complaints?: Array<{ __typename?: 'ConsultComplaint', key: string, since: string }> | null, shoes?: Array<{ __typename?: 'ConsultShoeInspection', brand: string, model: string, type: string, size: string }> | null } | null };

export type ListConsultsByPatientIdQueryVariables = Exact<{
  patient_id: Scalars['ID']['input'];
}>;


export type ListConsultsByPatientIdQuery = { __typename?: 'Query', listConsultsByPatientId: Array<{ __typename?: 'Consult', id: string, date: string, status: EConsultStatus, archived?: boolean | null, user_id: string }> };

export type ListOpenConsultsByTenantIdQueryVariables = Exact<{
  tenant_id: Scalars['ID']['input'];
}>;


export type ListOpenConsultsByTenantIdQuery = { __typename?: 'Query', listOpenConsultsByTenantId: Array<{ __typename?: 'Consult', id: string, date: string, status: EConsultStatus, archived?: boolean | null, user_id: string, patient_id: string, tenant_ref: string }> };

export type ListCountriesQueryVariables = Exact<{
  language: Scalars['String']['input'];
}>;


export type ListCountriesQuery = { __typename?: 'Query', listCountries: Array<{ __typename?: 'CountriesResponseItem', countryCode: string, name: string, rank: number }> };

export type GetDiagnosisInfoQueryVariables = Exact<{
  key: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type GetDiagnosisInfoQuery = { __typename?: 'Query', getDiagnosisInfo?: { __typename?: 'DiagnosisInfoResponse', key: string, info?: { __typename?: 'DiagnosisInfoData', title: string, chapters: Array<{ __typename?: 'DiagnosisInfoChapter', heading: string, content: string }> } | null } | null };

export type ListInsoleElementLibrariesByTenantIdQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  language: Scalars['String']['input'];
}>;


export type ListInsoleElementLibrariesByTenantIdQuery = { __typename?: 'Query', listInsoleElementLibrariesByTenantId: Array<{ __typename?: 'InsoleElementLibrary', id: string, name: string }> };

export type ListInsoleElementsQueryVariables = Exact<{
  language: Scalars['String']['input'];
}>;


export type ListInsoleElementsQuery = { __typename?: 'Query', listInsoleElements: Array<{ __typename?: 'InsoleElement', id: string, name: string, height_default?: number | null, height_min?: number | null, height_max?: number | null, height_adjustable?: boolean | null, manual: boolean, library: string }> };

export type ListInsoleElementsByTenantIdQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  language: Scalars['String']['input'];
}>;


export type ListInsoleElementsByTenantIdQuery = { __typename?: 'Query', listInsoleElementsByTenantId: Array<{ __typename?: 'InsoleElement', id: string, name: string, height_default?: number | null, height_min?: number | null, height_max?: number | null, height_adjustable?: boolean | null, manual: boolean, library: string }> };

export type ListInsoleElementIdsToHideQueryVariables = Exact<{ [key: string]: never; }>;


export type ListInsoleElementIdsToHideQuery = { __typename?: 'Query', listInsoleElementIdsToHide: Array<{ __typename?: 'InsoleElementIdsToHide', id: string, ids: Array<string> }> };

export type ListCustomElementFilesMutationVariables = Exact<{
  tenant_ref: Scalars['ID']['input'];
}>;


export type ListCustomElementFilesMutation = { __typename?: 'Mutation', listCustomElementFiles: Array<{ __typename?: 'CustomElementFile', identifier: string, key: string, checksum: string, modified_at: string }> };

export type ListInsolePlanOptionsByTenantIdQueryVariables = Exact<{
  language: Scalars['String']['input'];
  tenant_id: Scalars['ID']['input'];
}>;


export type ListInsolePlanOptionsByTenantIdQuery = { __typename?: 'Query', listInsolePlanOptionsByTenantId: Array<{ __typename?: 'InsolePlanOption', key: string, label: string, entity: EInsolePlanOptionEntity, production_methods?: Array<EProductionMethod | null> | null, rank: number, shoe_size_max?: number | null, shoe_size_min?: number | null, shoe_size_system?: EShoeSizeSystem | null, top_cover_colors?: Array<ETopCoverColor> | null }> };

export type CreateInsolePlanMutationVariables = Exact<{
  input: CreateInsolePlanInput;
}>;


export type CreateInsolePlanMutation = { __typename?: 'Mutation', createInsolePlan_v2: { __typename?: 'InsolePlan', id: string } };

export type DuplicateInsolePlanMutationVariables = Exact<{
  input: DuplicateInsolePlanInput;
}>;


export type DuplicateInsolePlanMutation = { __typename?: 'Mutation', duplicateInsolePlan: { __typename?: 'InsolePlan', id: string } };

export type GetInsolePlanByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInsolePlanByIdQuery = { __typename?: 'Query', getInsolePlanById?: { __typename?: 'InsolePlan', bottom_finish?: string | null, cad_model?: string | null, cad_snapshot?: string | null, consult_id: string, core_material?: string | null, created_at: string, finishing_by?: EFinishingBy | null, fore_foot_lateral_rotation_left?: number | null, fore_foot_lateral_rotation_right?: number | null, fore_foot_medial_rotation_left?: number | null, fore_foot_medial_rotation_right?: number | null, infill?: EInfill | null, id: string, insole_height?: number | null, insole_type?: string | null, manager_tenant_id: string, manager_tenant_ref: string, ground_sole_pattern?: string | null, ground_sole_thickness_left?: number | null, ground_sole_thickness_right?: number | null, heel_lift_left?: number | null, heel_lift_right?: number | null, hind_foot_left?: number | null, hind_foot_right?: number | null, middle_hind_foot_left?: number | null, middle_hind_foot_right?: number | null, modelling_required?: boolean | null, name: string, patient_id: string, production_method?: EProductionMethod | null, production_notes?: string | null, personal_notes?: string | null, side?: ESide | null, size?: number | null, size_system?: EShoeSizeSystem | null, scan_type?: EScanType | null, rear_foot_lateral_rotation_left?: number | null, rear_foot_lateral_rotation_right?: number | null, rear_foot_medial_rotation_left?: number | null, rear_foot_medial_rotation_right?: number | null, sole_lateral_rotation_left?: number | null, sole_lateral_rotation_right?: number | null, sole_medial_rotation_left?: number | null, sole_medial_rotation_right?: number | null, top_cover_material?: string | null, top_cover_color?: ETopCoverColor | null, deliver_top_cover_material_separately?: boolean | null, user_id: string, workshop?: string | null, workshop_tenant_ref?: string | null, elements?: Array<{ __typename?: 'InsolePlanElement', deliver_separately?: boolean | null, height_left?: number | null, height_right?: number | null, id: string, infill_left?: EInsoleElementInfill | null, infill_right?: EInsoleElementInfill | null, left: boolean, rhino_id_left?: string | null, rhino_id_right?: string | null, right: boolean }> | null, patched_insole_elements?: Array<{ __typename?: 'PatchedInsoleElement', library: string, name: string, infill?: string | null, thickness: number, side: string, rhino_id?: string | null }> | null } | null };

export type ListInsolePlansByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ListInsolePlansByIdsQuery = { __typename?: 'Query', listInsolePlansByIds: Array<{ __typename?: 'InsolePlan', id: string, modelling_required?: boolean | null, cad_model?: string | null, cad_snapshot?: string | null }> };

export type ListInsolePlansByConsultIdQueryVariables = Exact<{
  consult_id: Scalars['ID']['input'];
}>;


export type ListInsolePlansByConsultIdQuery = { __typename?: 'Query', listInsolePlansByConsultId: Array<{ __typename?: 'InsolePlan', bottom_finish?: string | null, cad_model?: string | null, created_at: string, core_material?: string | null, fore_foot_lateral_rotation_left?: number | null, fore_foot_lateral_rotation_right?: number | null, fore_foot_medial_rotation_left?: number | null, fore_foot_medial_rotation_right?: number | null, id: string, infill?: EInfill | null, insole_height?: number | null, insole_type?: string | null, finishing_by?: EFinishingBy | null, ground_sole_pattern?: string | null, ground_sole_thickness_left?: number | null, ground_sole_thickness_right?: number | null, heel_lift_left?: number | null, heel_lift_right?: number | null, hind_foot_left?: number | null, hind_foot_right?: number | null, manager_tenant_id: string, manager_tenant_ref: string, middle_hind_foot_left?: number | null, middle_hind_foot_right?: number | null, modelling_required?: boolean | null, name: string, patient_id: string, production_method?: EProductionMethod | null, production_notes?: string | null, personal_notes?: string | null, side?: ESide | null, size?: number | null, size_system?: EShoeSizeSystem | null, scan_type?: EScanType | null, rear_foot_lateral_rotation_left?: number | null, rear_foot_lateral_rotation_right?: number | null, rear_foot_medial_rotation_left?: number | null, rear_foot_medial_rotation_right?: number | null, sole_lateral_rotation_left?: number | null, sole_lateral_rotation_right?: number | null, sole_medial_rotation_left?: number | null, sole_medial_rotation_right?: number | null, top_cover_material?: string | null, top_cover_color?: ETopCoverColor | null, deliver_top_cover_material_separately?: boolean | null, workshop?: string | null, elements?: Array<{ __typename?: 'InsolePlanElement', deliver_separately?: boolean | null, height_left?: number | null, height_right?: number | null, id: string, infill_left?: EInsoleElementInfill | null, infill_right?: EInsoleElementInfill | null, left: boolean, rhino_id_left?: string | null, rhino_id_right?: string | null, right: boolean }> | null, patched_insole_elements?: Array<{ __typename?: 'PatchedInsoleElement', library: string, name: string, infill?: string | null, thickness: number, side: string, rhino_id?: string | null }> | null }> };

export type ListInsolePlanPreselectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListInsolePlanPreselectionsQuery = { __typename?: 'Query', listInsolePlanPreselections: Array<{ __typename?: 'InsolePlanPreselection', diagnosis?: string | null, foot_type?: string | null, insole_type?: string | null, element_ids: Array<string>, heel_lift: number, hind_foot: number, middle_hind_foot: number, rear_foot_lateral_rotation: number, rear_foot_medial_rotation: number, fore_foot_lateral_rotation: number, fore_foot_medial_rotation: number, ground_sole_thickness: number, sole_lateral_rotation: number, sole_medial_rotation: number }> };

export type UpdateInsolePlanMutationVariables = Exact<{
  input: UpdateInsolePlanInput;
}>;


export type UpdateInsolePlanMutation = { __typename?: 'Mutation', updateInsolePlan: { __typename?: 'InsolePlan', id: string, cad_model?: string | null, cad_snapshot?: string | null } };

export type DeleteInsolePlanMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteInsolePlanMutation = { __typename?: 'Mutation', deleteInsolePlan: { __typename?: 'DeleteInsolePlanResponse', id: string } };

export type GetOrderByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrderByIdQuery = { __typename?: 'Query', getOrderById?: { __typename?: 'Order', id: string, order_number: string, confirmed_at?: string | null, consult_id: string, is_urgent?: boolean | null, insole_plan_id: string, manager_tenant_id: string, manager_tenant_name: string, manager_user_id: string, patient_id: string, patient_name?: string | null, patient_date_of_birth?: string | null, production_method: EProductionMethod, shipping_target: EShippingTarget, scan_2d_templates?: Array<string> | null, scan_3d_templates?: Array<string> | null, scan_pp_templates?: Array<string> | null, shipped_at?: string | null, status: EOrderStatus, version_number: number, workshop_tenant_id: string, workshop_tenant_ref: string } | null };

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder?: { __typename?: 'UpdateConsultStatusResult', message?: string | null, success: boolean } | null };

export type UpdateOrderMutationVariables = Exact<{
  input: UpdateOrderInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder?: { __typename?: 'Order', id: string, status: EOrderStatus } | null };

export type UpdateOrdersMutationVariables = Exact<{
  input: Array<UpdateOrderInput> | UpdateOrderInput;
}>;


export type UpdateOrdersMutation = { __typename?: 'Mutation', updateOrders: Array<{ __typename?: 'Order', id: string, status: EOrderStatus } | null> };

export type ListOrdersByWorkshopTenantIdQueryVariables = Exact<{
  workshop_tenant_id: Scalars['ID']['input'];
  date_from?: InputMaybe<Scalars['String']['input']>;
  date_to?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListOrdersByWorkshopTenantIdQuery = { __typename?: 'Query', listOrdersByWorkshopTenantId: { __typename?: 'OrdersConnection', nextToken?: string | null, date_from?: string | null, date_to?: string | null, items: Array<{ __typename?: 'Order', attachments?: Array<string | null> | null, confirmed_at?: string | null, consult_id: string, created_at: string, id: string, insole_plan_id: string, is_urgent?: boolean | null, material?: string | null, manager_tenant_id: string, manager_tenant_name: string, manager_tenant_ref: string, manager_user_id: string, order_number: string, patient_id: string, patient_name?: string | null, patient_date_of_birth?: string | null, production_method: EProductionMethod, search_terms: string, shipped_at?: string | null, shipping_target: EShippingTarget, status: EOrderStatus, workshop_tenant_id: string, workshop_tenant_ref: string, version_number: number }> } };

export type ListOrdersByManagerTenantIdQueryVariables = Exact<{
  manager_tenant_id: Scalars['ID']['input'];
  date_from?: InputMaybe<Scalars['String']['input']>;
  date_to?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListOrdersByManagerTenantIdQuery = { __typename?: 'Query', listOrdersByManagerTenantId: { __typename?: 'OrdersConnection', nextToken?: string | null, date_from?: string | null, date_to?: string | null, items: Array<{ __typename?: 'Order', attachments?: Array<string | null> | null, confirmed_at?: string | null, consult_id: string, created_at: string, id: string, insole_plan_id: string, is_urgent?: boolean | null, manager_user_id: string, manager_tenant_id: string, manager_tenant_name: string, manager_tenant_ref: string, material?: string | null, order_number: string, patient_id: string, patient_name?: string | null, patient_date_of_birth?: string | null, production_method: EProductionMethod, search_terms: string, shipped_at?: string | null, shipping_target: EShippingTarget, status: EOrderStatus, workshop_tenant_id: string, workshop_tenant_ref: string, version_number: number }> } };

export type ListOrdersByPatientIdQueryVariables = Exact<{
  patient_id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListOrdersByPatientIdQuery = { __typename?: 'Query', listOrdersByPatientId: { __typename?: 'OrdersConnection', nextToken?: string | null, items: Array<{ __typename?: 'Order', attachments?: Array<string | null> | null, confirmed_at?: string | null, consult_id: string, created_at: string, id: string, insole_plan_id: string, is_urgent?: boolean | null, manager_user_id: string, manager_tenant_id: string, manager_tenant_name: string, manager_tenant_ref: string, material?: string | null, order_number: string, patient_id: string, patient_name?: string | null, patient_date_of_birth?: string | null, production_method: EProductionMethod, search_terms: string, shipped_at?: string | null, shipping_target: EShippingTarget, status: EOrderStatus, workshop_tenant_id: string, workshop_tenant_ref: string, version_number: number }> } };

export type ListOrdersByPatientIdAndSearchTermsQueryVariables = Exact<{
  patient_id: Scalars['ID']['input'];
  search_terms?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListOrdersByPatientIdAndSearchTermsQuery = { __typename?: 'Query', listOrdersByPatientIdAndSearchTerms: { __typename?: 'OrdersConnection', nextToken?: string | null, items: Array<{ __typename?: 'Order', attachments?: Array<string | null> | null, confirmed_at?: string | null, consult_id: string, created_at: string, id: string, insole_plan_id: string, is_urgent?: boolean | null, manager_tenant_id: string, manager_tenant_name: string, manager_tenant_ref: string, manager_user_id: string, material?: string | null, order_number: string, patient_id: string, patient_name?: string | null, patient_date_of_birth?: string | null, production_method: EProductionMethod, search_terms: string, shipped_at?: string | null, shipping_target: EShippingTarget, status: EOrderStatus, workshop_tenant_id: string, workshop_tenant_ref: string, version_number: number }> } };

export type OnOrderChangedSubscriptionVariables = Exact<{
  tenant_id: Scalars['ID']['input'];
}>;


export type OnOrderChangedSubscription = { __typename?: 'Subscription', onOrderChanged?: { __typename?: 'OrderChangedEvent', id: string, tenant_id: string, event_type: string } | null };

export type GetPatientByOrderIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPatientByOrderIdQuery = { __typename?: 'Query', getPatientByOrderId?: { __typename?: 'PatientByOrderId', id: string, patient_number: string, initials?: string | null, first_name?: string | null, middle_name?: string | null, last_name: string, external_id?: string | null, street?: string | null, house_number?: string | null, postal_code?: string | null, city?: string | null, province?: string | null, country?: string | null, title?: EPatientTitle | null } | null };

export type GetPatientByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPatientByIdQuery = { __typename?: 'Query', getPatientById?: { __typename?: 'Patient', id: string, patient_number: string, initials?: string | null, first_name?: string | null, middle_name?: string | null, last_name: string, date_of_birth: string, gender?: EPatientGender | null, id_type?: EPatientIdType | null, id_number?: string | null, bsn_number?: string | null, external_id?: string | null, health_insurer?: string | null, health_insurance_number?: string | null, street?: string | null, house_number?: string | null, postal_code?: string | null, city?: string | null, province?: string | null, country?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, status?: EPatientStatus | null, notes?: string | null, referrer?: string | null, title?: EPatientTitle | null, tenant_ref: string, tenant_id: string } | null };

export type GetPatientsCountByTenantIdQueryVariables = Exact<{
  tenant_id: Scalars['ID']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPatientsCountByTenantIdQuery = { __typename?: 'Query', getPatientsCountByTenantId: { __typename?: 'PatientsCount', count: number, nextToken?: string | null } };

export type ListPatientsByTenantIdQueryVariables = Exact<{
  tenant_id: Scalars['ID']['input'];
}>;


export type ListPatientsByTenantIdQuery = { __typename?: 'Query', listPatientsByTenantId: Array<{ __typename?: 'Patient', id: string, patient_number: string, external_id?: string | null, first_name?: string | null, middle_name?: string | null, last_name: string, date_of_birth: string, city?: string | null, mobile?: string | null, email?: string | null }> };

export type ListPatientsBySearchTermsQueryVariables = Exact<{
  tenant_id: Scalars['ID']['input'];
  search_terms?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListPatientsBySearchTermsQuery = { __typename?: 'Query', listPatientsBySearchTerms: { __typename?: 'PatientConnection', nextToken?: string | null, items: Array<{ __typename?: 'Patient', id: string, patient_number: string, external_id?: string | null, first_name?: string | null, middle_name?: string | null, last_name: string, date_of_birth: string, city?: string | null, mobile?: string | null, email?: string | null }> } };

export type CreatePatientMutationVariables = Exact<{
  input: CreatePatientInput;
}>;


export type CreatePatientMutation = { __typename?: 'Mutation', createPatient?: { __typename?: 'Patient', id: string } | null };

export type UpdatePatientMutationVariables = Exact<{
  input: UpdatePatientInput;
}>;


export type UpdatePatientMutation = { __typename?: 'Mutation', updatePatient?: { __typename?: 'Patient', id: string } | null };

export type AnonymizePatientMutationVariables = Exact<{
  input: AnonymizePatientInput;
}>;


export type AnonymizePatientMutation = { __typename?: 'Mutation', anonymizePatient?: { __typename?: 'Patient', id: string } | null };

export type ListPrinters3DByTenantIdQueryVariables = Exact<{
  tenant_id: Scalars['ID']['input'];
}>;


export type ListPrinters3DByTenantIdQuery = { __typename?: 'Query', listPrinters3DByTenantId: Array<{ __typename?: 'Printers3DItem', id: string, tenant_id: string, tenant_ref: string, name: string, description?: string | null, printer_slug: string, sort_order: number }> };

export type GetPrint3DLogByOrderIdQueryVariables = Exact<{
  order_id: Scalars['ID']['input'];
}>;


export type GetPrint3DLogByOrderIdQuery = { __typename?: 'Query', getPrint3DLogByOrderId?: { __typename?: 'Print3DLog', order_id: string, status: EPrintStatus, submitted_at?: string | null, started_at?: string | null, completed_at?: string | null, failed_at?: string | null, error_message?: string | null, runner_message_id?: string | null, input_prefix?: string | null, output_prefix?: string | null, print_attempt: number, selected_printer_id?: string | null, selected_printer_name?: string | null } | null };

export type CreatePrint3DJobMutationVariables = Exact<{
  input: CreatePrint3DJobInput;
}>;


export type CreatePrint3DJobMutation = { __typename?: 'Mutation', createPrint3DJob_v2: { __typename?: 'CreatePrint3DJobResult', order_id: string, status: EPrintStatus, message_id: string } };

export type ListReworkReasonsQueryVariables = Exact<{
  language: Scalars['String']['input'];
}>;


export type ListReworkReasonsQuery = { __typename?: 'Query', listReworkReasons: Array<{ __typename?: 'ReworkReason', key: string, label: string, rank: number, current_status: EOrderStatus }> };

export type GetScanByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetScanByIdQuery = { __typename?: 'Query', getScanById?: { __typename?: 'Scan', id: string, tenant_ref: string, patient_id: string, date: string, user_id: string, status?: EScanStatus | null, device: EScanDevice, modality: EScanModality, pixels_per_inch: number, original_url_both?: string | null, original_url_left?: string | null, original_url_right?: string | null, dicom_url_both?: string | null, dicom_url_left?: string | null, dicom_url_right?: string | null, thumbnail_url_both?: string | null, thumbnail_url_left?: string | null, thumbnail_url_right?: string | null, toolstate_url_both?: string | null, toolstate_url_left?: string | null, toolstate_url_right?: string | null, cad_template_url_left?: string | null, cad_template_url_right?: string | null } | null };

export type ListScansByPatientIdQueryVariables = Exact<{
  patient_id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListScansByPatientIdQuery = { __typename?: 'Query', listScansByPatientId: { __typename?: 'ScanConnection', nextToken?: string | null, items: Array<{ __typename?: 'Scan', id: string, tenant_ref: string, patient_id: string, date: string, user_id: string, status?: EScanStatus | null, device: EScanDevice, modality: EScanModality, pixels_per_inch: number, original_url_both?: string | null, original_url_left?: string | null, original_url_right?: string | null, dicom_url_both?: string | null, dicom_url_left?: string | null, dicom_url_right?: string | null, thumbnail_url_both?: string | null, thumbnail_url_left?: string | null, thumbnail_url_right?: string | null, toolstate_url_both?: string | null, toolstate_url_left?: string | null, toolstate_url_right?: string | null, cad_template_url_left?: string | null, cad_template_url_right?: string | null }> } };

export type ListScansByOrderIdQueryVariables = Exact<{
  order_id: Scalars['ID']['input'];
}>;


export type ListScansByOrderIdQuery = { __typename?: 'Query', listScansByOrderId_v2: Array<{ __typename?: 'Scan', id: string, device: EScanDevice, date: string, modality: EScanModality, pixels_per_inch: number, status?: EScanStatus | null, original_url_both?: string | null, original_url_left?: string | null, original_url_right?: string | null, dicom_url_both?: string | null, dicom_url_left?: string | null, dicom_url_right?: string | null, thumbnail_url_both?: string | null, thumbnail_url_left?: string | null, thumbnail_url_right?: string | null, toolstate_url_both?: string | null, toolstate_url_left?: string | null, toolstate_url_right?: string | null, cad_template_url_left?: string | null, cad_template_url_right?: string | null }> };

export type CreateScanMutationVariables = Exact<{
  input: CreateScanInput;
}>;


export type CreateScanMutation = { __typename?: 'Mutation', createScan: { __typename?: 'Scan', id: string } };

export type UpdateScanMutationVariables = Exact<{
  input: UpdateScanInput;
}>;


export type UpdateScanMutation = { __typename?: 'Mutation', updateScan: { __typename?: 'Scan', id: string } };

export type ReplaceScanOutputsMutationVariables = Exact<{
  input: ReplaceScanOutputsInput;
}>;


export type ReplaceScanOutputsMutation = { __typename?: 'Mutation', replaceScanOutputs: { __typename?: 'ReplaceScanOutputsResponse', scans: Array<{ __typename?: 'Scan', id: string }> } };

export type CreateUploadFilePresignedUrlMutationVariables = Exact<{
  tenant_ref: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
}>;


export type CreateUploadFilePresignedUrlMutation = { __typename?: 'Mutation', createUploadFilePresignedUrl: { __typename?: 'SignedUrlResult', bucket: string, key: string, url: string, expiresIn: number, method: ESignedUrlMethod } };

export type CreateDownloadFilePresignedUrlMutationVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type CreateDownloadFilePresignedUrlMutation = { __typename?: 'Mutation', createDownloadFilePresignedUrl: { __typename?: 'SignedUrlResult', bucket: string, key: string, url: string, expiresIn: number, method: ESignedUrlMethod } };

export type DeleteScanMutationVariables = Exact<{
  scan: DeleteScanInput;
}>;


export type DeleteScanMutation = { __typename?: 'Mutation', deleteScan: { __typename?: 'DeleteScanResponse', success: boolean, message?: string | null } };

export type ListTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListTenantsQuery = { __typename?: 'Query', listTenants: Array<{ __typename?: 'Tenant', id: string, name: string, parent_id?: string | null, profile?: ETenantProfile | null, tenant_ref: string, does_own_modelling?: boolean | null, workshop_milling_tenant_id?: string | null, workshop_milling_tenant_ref?: string | null, workshop_milling_tenant_name?: string | null, workshop_printing_tenant_id?: string | null, workshop_printing_tenant_ref?: string | null, workshop_printing_tenant_name?: string | null }> };

export type ListWorkshopTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListWorkshopTenantsQuery = { __typename?: 'Query', listWorkshopTenants: Array<{ __typename?: 'WorkshopTenant', id: string, name: string }> };

export type ListTenantParentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListTenantParentsQuery = { __typename?: 'Query', listTenantParents: Array<{ __typename?: 'Tenant', id: string, name: string, parent_id?: string | null, profile?: ETenantProfile | null, tenant_ref: string, does_own_modelling?: boolean | null, workshop_milling_tenant_id?: string | null, workshop_milling_tenant_ref?: string | null, workshop_milling_tenant_name?: string | null, workshop_printing_tenant_id?: string | null, workshop_printing_tenant_ref?: string | null, workshop_printing_tenant_name?: string | null }> };

export type ListTenantsByWorkshopTenantIdQueryVariables = Exact<{
  workshop_tenant_id: Scalars['ID']['input'];
}>;


export type ListTenantsByWorkshopTenantIdQuery = { __typename?: 'Query', listTenantsByWorkshopTenantId: Array<{ __typename?: 'Tenant', city?: string | null, country?: string | null, does_own_modelling?: boolean | null, house_number?: string | null, id: string, name: string, postal_code?: string | null, profile?: ETenantProfile | null, street?: string | null, tenant_ref: string }> };

export type CreateTenantMutationVariables = Exact<{
  input: CreateTenantInput;
}>;


export type CreateTenantMutation = { __typename?: 'Mutation', createTenant: { __typename?: 'Tenant', id: string, name: string } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'CreateUserResponse', success: boolean, message?: string | null, username?: string | null } };

export const AnnouncementFieldsFragmentDoc = gql`
    fragment AnnouncementFields on Announcement {
  id
  title
  appType
  messages {
    nl_NL
    de_DE
    en_US
    fr_FR
    fi_FI
  }
  start_date
  end_date
}
    `;
export const ListAnnouncementsDocument = gql`
    query ListAnnouncements {
  listAnnouncements {
    ...AnnouncementFields
  }
}
    ${AnnouncementFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListAnnouncementsGQL extends Apollo.Query<ListAnnouncementsQuery, ListAnnouncementsQueryVariables> {
    document = ListAnnouncementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAnnouncementDocument = gql`
    mutation CreateAnnouncement($input: CreateAnnouncementInput!) {
  createAnnouncement(input: $input) {
    ...AnnouncementFields
  }
}
    ${AnnouncementFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAnnouncementGQL extends Apollo.Mutation<CreateAnnouncementMutation, CreateAnnouncementMutationVariables> {
    document = CreateAnnouncementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAnnouncementDocument = gql`
    mutation UpdateAnnouncement($input: UpdateAnnouncementInput!) {
  updateAnnouncement(input: $input) {
    ...AnnouncementFields
  }
}
    ${AnnouncementFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAnnouncementGQL extends Apollo.Mutation<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables> {
    document = UpdateAnnouncementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAnnouncementDocument = gql`
    mutation DeleteAnnouncement($id: ID!) {
  deleteAnnouncement(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAnnouncementGQL extends Apollo.Mutation<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables> {
    document = DeleteAnnouncementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnAnnouncementChangedDocument = gql`
    subscription OnAnnouncementChanged {
  onAnnouncementChanged {
    id
    event_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnAnnouncementChangedGQL extends Apollo.Subscription<OnAnnouncementChangedSubscription, OnAnnouncementChangedSubscriptionVariables> {
    document = OnAnnouncementChangedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAvailabilityByIdDocument = gql`
    query GetAvailabilityById($id: ID!) {
  getAvailabilityById(id: $id) {
    id
    status
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAvailabilityByIdGQL extends Apollo.Query<GetAvailabilityByIdQuery, GetAvailabilityByIdQueryVariables> {
    document = GetAvailabilityByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnAvailabilityChangedDocument = gql`
    subscription OnAvailabilityChanged {
  onAvailabilityChanged {
    id
    status
    event_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnAvailabilityChangedGQL extends Apollo.Subscription<OnAvailabilityChangedSubscription, OnAvailabilityChangedSubscriptionVariables> {
    document = OnAvailabilityChangedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBackendSignalDocument = gql`
    query GetBackendSignal($key: ID!) {
  getBackendSignal(key: $key) {
    key
    value
    updated_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBackendSignalGQL extends Apollo.Query<GetBackendSignalQuery, GetBackendSignalQueryVariables> {
    document = GetBackendSignalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnBackendSignalChangedDocument = gql`
    subscription OnBackendSignalChanged($key: ID!) {
  onBackendSignalChanged(key: $key) {
    key
    value
    updated_at
    event_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnBackendSignalChangedGQL extends Apollo.Subscription<OnBackendSignalChangedSubscription, OnBackendSignalChangedSubscriptionVariables> {
    document = OnBackendSignalChangedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListConsultOptionsDocument = gql`
    query ListConsultOptions($language: String!) {
  listConsultOptions(language: $language) {
    key
    label
    entity
    rank
    searchterms
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListConsultOptionsGQL extends Apollo.Query<ListConsultOptionsQuery, ListConsultOptionsQueryVariables> {
    document = ListConsultOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConsultByOrderIdDocument = gql`
    query GetConsultByOrderId($id: ID!) {
  getConsultByOrderId(id: $id) {
    notes
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConsultByOrderIdGQL extends Apollo.Query<GetConsultByOrderIdQuery, GetConsultByOrderIdQueryVariables> {
    document = GetConsultByOrderIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConsultByIdDocument = gql`
    query GetConsultById($id: ID!) {
  getConsultById(id: $id) {
    id
    tenant_ref
    patient_id
    date
    user_id
    status
    archived
    referring_practitioner
    referring_via
    occupations {
      key
      score
    }
    sports {
      key
      frequency
      score
    }
    hobbies {
      key
      score
    }
    average_pain_score
    maximum_pain_score
    vas_score
    essential_info {
      predefined_question
      checked
    }
    essential_info_notes
    reason_visit
    medical_history
    pathologies {
      key
    }
    weight
    complaints {
      key
      since
    }
    main_goal
    notes
    shoes {
      brand
      model
      type
      size
    }
    insole_existing
    insole_notes
    foot_type_left
    foot_type_right
    pelvis_left
    pelvis_right
    hips_left
    hips_right
    knees_left
    knees_right
    tibia_left
    tibia_right
    forefoot_angle_left
    forefoot_angle_right
    mt1_mobility_left
    mt1_mobility_right
    mtp1_dorsalflexi_rom_left
    mtp1_dorsalflexi_rom_right
    general_inspection
    remarks
    dynamic_analyse_left
    dynamic_analyse_right
    dynamic_analyse_remark
    walk_run_technic
    kneeing_in_left
    kneeing_in_right
    trendelenburg_left
    trendelenburg_right
    squat_left
    squat_right
    one_leg_general_coordination_left
    one_leg_general_coordination_right
    one_leg_ankle_coordination_left
    one_leg_ankle_coordination_right
    one_leg_knee_coordination_left
    one_leg_knee_coordination_right
    one_leg_body_coordination_left
    one_leg_body_coordination_right
    active_assessment
    passive_assessment
    resistance_tests
    additional_tests
    sensitive_to_stress
    posture
    physical_age
    follow_up_comments
    follow_up_vas_score
    evaluation_name
    evaluation_date
    recovery
    satisfaction
    evaluation_psk_work
    evaluation_psk_sport
    evaluation_psk_hobby
    evaluation_average_pain_score
    evaluation_maximum_pain_score
    evaluation_notes
    enable_reminder
    months_before_reminder
    scan_2d_templates
    scan_3d_templates
    scan_pp_templates
    diagnosis
    shoe_advise
    exercises
    referrals
    conclusion
    profile_b_diagnosis
    profile_b_foot_type_left
    profile_b_foot_type_right
    profile_b_notes
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConsultByIdGQL extends Apollo.Query<GetConsultByIdQuery, GetConsultByIdQueryVariables> {
    document = GetConsultByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateConsultDocument = gql`
    mutation CreateConsult($input: ConsultInput!) {
  createConsult(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateConsultGQL extends Apollo.Mutation<CreateConsultMutation, CreateConsultMutationVariables> {
    document = CreateConsultDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CopyConsultDocument = gql`
    mutation CopyConsult($consult_id: ID!) {
  copyConsult(consult_id: $consult_id) {
    consult_id
    insole_plan_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CopyConsultGQL extends Apollo.Mutation<CopyConsultMutation, CopyConsultMutationVariables> {
    document = CopyConsultDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteConsultDocument = gql`
    mutation DeleteConsult($consult_id: ID!) {
  deleteConsult(consult_id: $consult_id) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteConsultGQL extends Apollo.Mutation<DeleteConsultMutation, DeleteConsultMutationVariables> {
    document = DeleteConsultDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetConsultArchivedDocument = gql`
    mutation SetConsultArchived($consult_id: ID!, $archived: Boolean!) {
  setConsultArchived(consult_id: $consult_id, archived: $archived) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetConsultArchivedGQL extends Apollo.Mutation<SetConsultArchivedMutation, SetConsultArchivedMutationVariables> {
    document = SetConsultArchivedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateConsultDocument = gql`
    mutation UpdateConsult($input: ConsultExtendedInput!) {
  updateConsult(input: $input) {
    id
    tenant_ref
    patient_id
    date
    user_id
    status
    archived
    referring_practitioner
    referring_via
    occupations {
      key
      score
    }
    sports {
      key
      frequency
      score
    }
    hobbies {
      key
      score
    }
    average_pain_score
    maximum_pain_score
    vas_score
    essential_info {
      predefined_question
      checked
    }
    essential_info_notes
    reason_visit
    medical_history
    pathologies {
      key
    }
    weight
    complaints {
      key
      since
    }
    main_goal
    notes
    shoes {
      brand
      model
      type
      size
    }
    insole_existing
    insole_notes
    foot_type_left
    foot_type_right
    pelvis_left
    pelvis_right
    hips_left
    hips_right
    knees_left
    knees_right
    tibia_left
    tibia_right
    forefoot_angle_left
    forefoot_angle_right
    mt1_mobility_left
    mt1_mobility_right
    mtp1_dorsalflexi_rom_left
    mtp1_dorsalflexi_rom_right
    general_inspection
    remarks
    dynamic_analyse_left
    dynamic_analyse_right
    dynamic_analyse_remark
    walk_run_technic
    kneeing_in_left
    kneeing_in_right
    trendelenburg_left
    trendelenburg_right
    squat_left
    squat_right
    one_leg_general_coordination_left
    one_leg_general_coordination_right
    one_leg_ankle_coordination_left
    one_leg_ankle_coordination_right
    one_leg_knee_coordination_left
    one_leg_knee_coordination_right
    one_leg_body_coordination_left
    one_leg_body_coordination_right
    active_assessment
    passive_assessment
    resistance_tests
    additional_tests
    sensitive_to_stress
    posture
    physical_age
    diagnosis
    shoe_advise
    exercises
    referrals
    conclusion
    profile_b_diagnosis
    profile_b_foot_type_left
    profile_b_foot_type_right
    profile_b_notes
    follow_up_comments
    follow_up_vas_score
    evaluation_name
    evaluation_date
    recovery
    satisfaction
    evaluation_psk_work
    evaluation_psk_sport
    evaluation_psk_hobby
    evaluation_average_pain_score
    evaluation_maximum_pain_score
    evaluation_notes
    enable_reminder
    months_before_reminder
    scan_2d_templates
    scan_3d_templates
    scan_pp_templates
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateConsultGQL extends Apollo.Mutation<UpdateConsultMutation, UpdateConsultMutationVariables> {
    document = UpdateConsultDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListConsultsByPatientIdDocument = gql`
    query ListConsultsByPatientId($patient_id: ID!) {
  listConsultsByPatientId(patient_id: $patient_id) {
    id
    date
    status
    archived
    user_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListConsultsByPatientIdGQL extends Apollo.Query<ListConsultsByPatientIdQuery, ListConsultsByPatientIdQueryVariables> {
    document = ListConsultsByPatientIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListOpenConsultsByTenantIdDocument = gql`
    query ListOpenConsultsByTenantId($tenant_id: ID!) {
  listOpenConsultsByTenantId(tenant_id: $tenant_id) {
    id
    date
    status
    archived
    user_id
    patient_id
    tenant_ref
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListOpenConsultsByTenantIdGQL extends Apollo.Query<ListOpenConsultsByTenantIdQuery, ListOpenConsultsByTenantIdQueryVariables> {
    document = ListOpenConsultsByTenantIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListCountriesDocument = gql`
    query ListCountries($language: String!) {
  listCountries(language: $language) {
    countryCode
    name
    rank
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListCountriesGQL extends Apollo.Query<ListCountriesQuery, ListCountriesQueryVariables> {
    document = ListCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDiagnosisInfoDocument = gql`
    query GetDiagnosisInfo($key: String!, $language: String!) {
  getDiagnosisInfo(key: $key, language: $language) {
    key
    info {
      title
      chapters {
        heading
        content
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDiagnosisInfoGQL extends Apollo.Query<GetDiagnosisInfoQuery, GetDiagnosisInfoQueryVariables> {
    document = GetDiagnosisInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListInsoleElementLibrariesByTenantIdDocument = gql`
    query ListInsoleElementLibrariesByTenantId($tenantId: ID!, $language: String!) {
  listInsoleElementLibrariesByTenantId(tenant_id: $tenantId, language: $language) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListInsoleElementLibrariesByTenantIdGQL extends Apollo.Query<ListInsoleElementLibrariesByTenantIdQuery, ListInsoleElementLibrariesByTenantIdQueryVariables> {
    document = ListInsoleElementLibrariesByTenantIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListInsoleElementsDocument = gql`
    query ListInsoleElements($language: String!) {
  listInsoleElements(language: $language) {
    id
    name
    height_default
    height_min
    height_max
    height_adjustable
    manual
    library
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListInsoleElementsGQL extends Apollo.Query<ListInsoleElementsQuery, ListInsoleElementsQueryVariables> {
    document = ListInsoleElementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListInsoleElementsByTenantIdDocument = gql`
    query ListInsoleElementsByTenantId($tenantId: ID!, $language: String!) {
  listInsoleElementsByTenantId(tenant_id: $tenantId, language: $language) {
    id
    name
    height_default
    height_min
    height_max
    height_adjustable
    manual
    library
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListInsoleElementsByTenantIdGQL extends Apollo.Query<ListInsoleElementsByTenantIdQuery, ListInsoleElementsByTenantIdQueryVariables> {
    document = ListInsoleElementsByTenantIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListInsoleElementIdsToHideDocument = gql`
    query ListInsoleElementIdsToHide {
  listInsoleElementIdsToHide {
    id
    ids
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListInsoleElementIdsToHideGQL extends Apollo.Query<ListInsoleElementIdsToHideQuery, ListInsoleElementIdsToHideQueryVariables> {
    document = ListInsoleElementIdsToHideDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListCustomElementFilesDocument = gql`
    mutation ListCustomElementFiles($tenant_ref: ID!) {
  listCustomElementFiles(tenant_ref: $tenant_ref) {
    identifier
    key
    checksum
    modified_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListCustomElementFilesGQL extends Apollo.Mutation<ListCustomElementFilesMutation, ListCustomElementFilesMutationVariables> {
    document = ListCustomElementFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListInsolePlanOptionsByTenantIdDocument = gql`
    query ListInsolePlanOptionsByTenantId($language: String!, $tenant_id: ID!) {
  listInsolePlanOptionsByTenantId(language: $language, tenant_id: $tenant_id) {
    key
    label
    entity
    production_methods
    rank
    shoe_size_max
    shoe_size_min
    shoe_size_system
    top_cover_colors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListInsolePlanOptionsByTenantIdGQL extends Apollo.Query<ListInsolePlanOptionsByTenantIdQuery, ListInsolePlanOptionsByTenantIdQueryVariables> {
    document = ListInsolePlanOptionsByTenantIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateInsolePlanDocument = gql`
    mutation CreateInsolePlan($input: CreateInsolePlanInput!) {
  createInsolePlan_v2(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateInsolePlanGQL extends Apollo.Mutation<CreateInsolePlanMutation, CreateInsolePlanMutationVariables> {
    document = CreateInsolePlanDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateInsolePlanDocument = gql`
    mutation DuplicateInsolePlan($input: DuplicateInsolePlanInput!) {
  duplicateInsolePlan(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateInsolePlanGQL extends Apollo.Mutation<DuplicateInsolePlanMutation, DuplicateInsolePlanMutationVariables> {
    document = DuplicateInsolePlanDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInsolePlanByIdDocument = gql`
    query GetInsolePlanById($id: ID!) {
  getInsolePlanById(id: $id) {
    bottom_finish
    cad_model
    cad_snapshot
    consult_id
    core_material
    created_at
    elements {
      deliver_separately
      height_left
      height_right
      id
      infill_left
      infill_right
      left
      rhino_id_left
      rhino_id_right
      right
    }
    patched_insole_elements {
      library
      name
      infill
      thickness
      side
      rhino_id
    }
    finishing_by
    fore_foot_lateral_rotation_left
    fore_foot_lateral_rotation_right
    fore_foot_medial_rotation_left
    fore_foot_medial_rotation_right
    infill
    id
    insole_height
    insole_type
    manager_tenant_id
    manager_tenant_ref
    ground_sole_pattern
    ground_sole_thickness_left
    ground_sole_thickness_right
    heel_lift_left
    heel_lift_right
    hind_foot_left
    hind_foot_right
    middle_hind_foot_left
    middle_hind_foot_right
    modelling_required
    name
    patient_id
    production_method
    production_notes
    personal_notes
    side
    size
    size_system
    scan_type
    rear_foot_lateral_rotation_left
    rear_foot_lateral_rotation_right
    rear_foot_medial_rotation_left
    rear_foot_medial_rotation_right
    sole_lateral_rotation_left
    sole_lateral_rotation_right
    sole_medial_rotation_left
    sole_medial_rotation_right
    top_cover_material
    top_cover_color
    deliver_top_cover_material_separately
    user_id
    workshop
    workshop_tenant_ref
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInsolePlanByIdGQL extends Apollo.Query<GetInsolePlanByIdQuery, GetInsolePlanByIdQueryVariables> {
    document = GetInsolePlanByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListInsolePlansByIdsDocument = gql`
    query ListInsolePlansByIds($ids: [ID!]!) {
  listInsolePlansByIds(ids: $ids) {
    id
    modelling_required
    cad_model
    cad_snapshot
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListInsolePlansByIdsGQL extends Apollo.Query<ListInsolePlansByIdsQuery, ListInsolePlansByIdsQueryVariables> {
    document = ListInsolePlansByIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListInsolePlansByConsultIdDocument = gql`
    query ListInsolePlansByConsultId($consult_id: ID!) {
  listInsolePlansByConsultId(consult_id: $consult_id) {
    bottom_finish
    cad_model
    created_at
    core_material
    elements {
      deliver_separately
      height_left
      height_right
      id
      infill_left
      infill_right
      left
      rhino_id_left
      rhino_id_right
      right
    }
    patched_insole_elements {
      library
      name
      infill
      thickness
      side
      rhino_id
    }
    fore_foot_lateral_rotation_left
    fore_foot_lateral_rotation_right
    fore_foot_medial_rotation_left
    fore_foot_medial_rotation_right
    id
    infill
    insole_height
    insole_type
    finishing_by
    ground_sole_pattern
    ground_sole_thickness_left
    ground_sole_thickness_right
    heel_lift_left
    heel_lift_right
    hind_foot_left
    hind_foot_right
    manager_tenant_id
    manager_tenant_ref
    middle_hind_foot_left
    middle_hind_foot_right
    modelling_required
    name
    patient_id
    production_method
    production_notes
    personal_notes
    side
    size
    size_system
    scan_type
    rear_foot_lateral_rotation_left
    rear_foot_lateral_rotation_right
    rear_foot_medial_rotation_left
    rear_foot_medial_rotation_right
    sole_lateral_rotation_left
    sole_lateral_rotation_right
    sole_medial_rotation_left
    sole_medial_rotation_right
    top_cover_material
    top_cover_color
    deliver_top_cover_material_separately
    workshop
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListInsolePlansByConsultIdGQL extends Apollo.Query<ListInsolePlansByConsultIdQuery, ListInsolePlansByConsultIdQueryVariables> {
    document = ListInsolePlansByConsultIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListInsolePlanPreselectionsDocument = gql`
    query ListInsolePlanPreselections {
  listInsolePlanPreselections {
    diagnosis
    foot_type
    insole_type
    element_ids
    heel_lift
    hind_foot
    middle_hind_foot
    rear_foot_lateral_rotation
    rear_foot_medial_rotation
    fore_foot_lateral_rotation
    fore_foot_medial_rotation
    ground_sole_thickness
    sole_lateral_rotation
    sole_medial_rotation
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListInsolePlanPreselectionsGQL extends Apollo.Query<ListInsolePlanPreselectionsQuery, ListInsolePlanPreselectionsQueryVariables> {
    document = ListInsolePlanPreselectionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateInsolePlanDocument = gql`
    mutation UpdateInsolePlan($input: UpdateInsolePlanInput!) {
  updateInsolePlan(input: $input) {
    id
    cad_model
    cad_snapshot
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateInsolePlanGQL extends Apollo.Mutation<UpdateInsolePlanMutation, UpdateInsolePlanMutationVariables> {
    document = UpdateInsolePlanDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteInsolePlanDocument = gql`
    mutation DeleteInsolePlan($id: ID!) {
  deleteInsolePlan(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteInsolePlanGQL extends Apollo.Mutation<DeleteInsolePlanMutation, DeleteInsolePlanMutationVariables> {
    document = DeleteInsolePlanDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrderByIdDocument = gql`
    query GetOrderById($id: ID!) {
  getOrderById(id: $id) {
    id
    order_number
    confirmed_at
    consult_id
    is_urgent
    insole_plan_id
    manager_tenant_id
    manager_tenant_name
    manager_user_id
    patient_id
    patient_name
    patient_date_of_birth
    production_method
    shipping_target
    scan_2d_templates
    scan_3d_templates
    scan_pp_templates
    shipped_at
    status
    version_number
    workshop_tenant_id
    workshop_tenant_ref
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrderByIdGQL extends Apollo.Query<GetOrderByIdQuery, GetOrderByIdQueryVariables> {
    document = GetOrderByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrderDocument = gql`
    mutation CreateOrder($input: CreateOrderInput!) {
  createOrder(input: $input) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrderGQL extends Apollo.Mutation<CreateOrderMutation, CreateOrderMutationVariables> {
    document = CreateOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($input: UpdateOrderInput!) {
  updateOrder(input: $input) {
    id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrderGQL extends Apollo.Mutation<UpdateOrderMutation, UpdateOrderMutationVariables> {
    document = UpdateOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrdersDocument = gql`
    mutation UpdateOrders($input: [UpdateOrderInput!]!) {
  updateOrders(input: $input) {
    id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrdersGQL extends Apollo.Mutation<UpdateOrdersMutation, UpdateOrdersMutationVariables> {
    document = UpdateOrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListOrdersByWorkshopTenantIdDocument = gql`
    query ListOrdersByWorkshopTenantId($workshop_tenant_id: ID!, $date_from: String, $date_to: String, $limit: Int, $nextToken: String) {
  listOrdersByWorkshopTenantId(
    workshop_tenant_id: $workshop_tenant_id
    date_from: $date_from
    date_to: $date_to
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      attachments
      confirmed_at
      consult_id
      created_at
      id
      insole_plan_id
      is_urgent
      material
      manager_tenant_id
      manager_tenant_name
      manager_tenant_ref
      manager_user_id
      order_number
      patient_id
      patient_name
      patient_date_of_birth
      production_method
      search_terms
      shipped_at
      shipping_target
      status
      workshop_tenant_id
      workshop_tenant_ref
      version_number
    }
    nextToken
    date_from
    date_to
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListOrdersByWorkshopTenantIdGQL extends Apollo.Query<ListOrdersByWorkshopTenantIdQuery, ListOrdersByWorkshopTenantIdQueryVariables> {
    document = ListOrdersByWorkshopTenantIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListOrdersByManagerTenantIdDocument = gql`
    query ListOrdersByManagerTenantId($manager_tenant_id: ID!, $date_from: String, $date_to: String, $limit: Int, $nextToken: String) {
  listOrdersByManagerTenantId(
    manager_tenant_id: $manager_tenant_id
    date_from: $date_from
    date_to: $date_to
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      attachments
      confirmed_at
      consult_id
      created_at
      id
      insole_plan_id
      is_urgent
      manager_user_id
      manager_tenant_id
      manager_tenant_name
      manager_tenant_ref
      material
      order_number
      patient_id
      patient_name
      patient_date_of_birth
      production_method
      search_terms
      shipped_at
      shipping_target
      status
      workshop_tenant_id
      workshop_tenant_ref
      version_number
    }
    nextToken
    date_from
    date_to
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListOrdersByManagerTenantIdGQL extends Apollo.Query<ListOrdersByManagerTenantIdQuery, ListOrdersByManagerTenantIdQueryVariables> {
    document = ListOrdersByManagerTenantIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListOrdersByPatientIdDocument = gql`
    query ListOrdersByPatientId($patient_id: ID!, $limit: Int, $nextToken: String) {
  listOrdersByPatientId(
    patient_id: $patient_id
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      attachments
      confirmed_at
      consult_id
      created_at
      id
      insole_plan_id
      is_urgent
      manager_user_id
      manager_tenant_id
      manager_tenant_name
      manager_tenant_ref
      material
      order_number
      patient_id
      patient_name
      patient_date_of_birth
      production_method
      search_terms
      shipped_at
      shipping_target
      status
      workshop_tenant_id
      workshop_tenant_ref
      version_number
    }
    nextToken
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListOrdersByPatientIdGQL extends Apollo.Query<ListOrdersByPatientIdQuery, ListOrdersByPatientIdQueryVariables> {
    document = ListOrdersByPatientIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListOrdersByPatientIdAndSearchTermsDocument = gql`
    query ListOrdersByPatientIdAndSearchTerms($patient_id: ID!, $search_terms: String, $limit: Int, $nextToken: String) {
  listOrdersByPatientIdAndSearchTerms(
    patient_id: $patient_id
    search_terms: $search_terms
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      attachments
      confirmed_at
      consult_id
      created_at
      id
      insole_plan_id
      is_urgent
      manager_tenant_id
      manager_tenant_name
      manager_tenant_ref
      manager_user_id
      material
      order_number
      patient_id
      patient_name
      patient_date_of_birth
      production_method
      search_terms
      shipped_at
      shipping_target
      status
      workshop_tenant_id
      workshop_tenant_ref
      version_number
    }
    nextToken
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListOrdersByPatientIdAndSearchTermsGQL extends Apollo.Query<ListOrdersByPatientIdAndSearchTermsQuery, ListOrdersByPatientIdAndSearchTermsQueryVariables> {
    document = ListOrdersByPatientIdAndSearchTermsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnOrderChangedDocument = gql`
    subscription OnOrderChanged($tenant_id: ID!) {
  onOrderChanged(tenant_id: $tenant_id) {
    id
    tenant_id
    event_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnOrderChangedGQL extends Apollo.Subscription<OnOrderChangedSubscription, OnOrderChangedSubscriptionVariables> {
    document = OnOrderChangedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPatientByOrderIdDocument = gql`
    query GetPatientByOrderId($id: ID!) {
  getPatientByOrderId(id: $id) {
    id
    patient_number
    initials
    first_name
    middle_name
    last_name
    external_id
    street
    house_number
    postal_code
    city
    province
    country
    title
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPatientByOrderIdGQL extends Apollo.Query<GetPatientByOrderIdQuery, GetPatientByOrderIdQueryVariables> {
    document = GetPatientByOrderIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPatientByIdDocument = gql`
    query GetPatientById($id: ID!) {
  getPatientById(id: $id) {
    id
    patient_number
    initials
    first_name
    middle_name
    last_name
    date_of_birth
    gender
    id_type
    id_number
    bsn_number
    external_id
    health_insurer
    health_insurance_number
    street
    house_number
    postal_code
    city
    province
    country
    email
    phone
    mobile
    status
    notes
    referrer
    title
    tenant_ref
    tenant_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPatientByIdGQL extends Apollo.Query<GetPatientByIdQuery, GetPatientByIdQueryVariables> {
    document = GetPatientByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPatientsCountByTenantIdDocument = gql`
    query GetPatientsCountByTenantId($tenant_id: ID!, $nextToken: String) {
  getPatientsCountByTenantId(tenant_id: $tenant_id, nextToken: $nextToken) {
    count
    nextToken
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPatientsCountByTenantIdGQL extends Apollo.Query<GetPatientsCountByTenantIdQuery, GetPatientsCountByTenantIdQueryVariables> {
    document = GetPatientsCountByTenantIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListPatientsByTenantIdDocument = gql`
    query ListPatientsByTenantId($tenant_id: ID!) {
  listPatientsByTenantId(tenant_id: $tenant_id) {
    id
    patient_number
    external_id
    first_name
    middle_name
    last_name
    date_of_birth
    city
    mobile
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListPatientsByTenantIdGQL extends Apollo.Query<ListPatientsByTenantIdQuery, ListPatientsByTenantIdQueryVariables> {
    document = ListPatientsByTenantIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListPatientsBySearchTermsDocument = gql`
    query ListPatientsBySearchTerms($tenant_id: ID!, $search_terms: String, $limit: Int, $nextToken: String) {
  listPatientsBySearchTerms(
    tenant_id: $tenant_id
    search_terms: $search_terms
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      patient_number
      external_id
      first_name
      middle_name
      last_name
      date_of_birth
      city
      mobile
      email
    }
    nextToken
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListPatientsBySearchTermsGQL extends Apollo.Query<ListPatientsBySearchTermsQuery, ListPatientsBySearchTermsQueryVariables> {
    document = ListPatientsBySearchTermsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePatientDocument = gql`
    mutation CreatePatient($input: CreatePatientInput!) {
  createPatient(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePatientGQL extends Apollo.Mutation<CreatePatientMutation, CreatePatientMutationVariables> {
    document = CreatePatientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePatientDocument = gql`
    mutation UpdatePatient($input: UpdatePatientInput!) {
  updatePatient(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePatientGQL extends Apollo.Mutation<UpdatePatientMutation, UpdatePatientMutationVariables> {
    document = UpdatePatientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnonymizePatientDocument = gql`
    mutation AnonymizePatient($input: AnonymizePatientInput!) {
  anonymizePatient(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AnonymizePatientGQL extends Apollo.Mutation<AnonymizePatientMutation, AnonymizePatientMutationVariables> {
    document = AnonymizePatientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListPrinters3DByTenantIdDocument = gql`
    query ListPrinters3DByTenantId($tenant_id: ID!) {
  listPrinters3DByTenantId(tenant_id: $tenant_id) {
    id
    tenant_id
    tenant_ref
    name
    description
    printer_slug
    sort_order
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListPrinters3DByTenantIdGQL extends Apollo.Query<ListPrinters3DByTenantIdQuery, ListPrinters3DByTenantIdQueryVariables> {
    document = ListPrinters3DByTenantIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPrint3DLogByOrderIdDocument = gql`
    query GetPrint3DLogByOrderId($order_id: ID!) {
  getPrint3DLogByOrderId(order_id: $order_id) {
    order_id
    status
    submitted_at
    started_at
    completed_at
    failed_at
    error_message
    runner_message_id
    input_prefix
    output_prefix
    print_attempt
    selected_printer_id
    selected_printer_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPrint3DLogByOrderIdGQL extends Apollo.Query<GetPrint3DLogByOrderIdQuery, GetPrint3DLogByOrderIdQueryVariables> {
    document = GetPrint3DLogByOrderIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePrint3DJobDocument = gql`
    mutation CreatePrint3DJob($input: CreatePrint3DJobInput!) {
  createPrint3DJob_v2(input: $input) {
    order_id
    status
    message_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePrint3DJobGQL extends Apollo.Mutation<CreatePrint3DJobMutation, CreatePrint3DJobMutationVariables> {
    document = CreatePrint3DJobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListReworkReasonsDocument = gql`
    query ListReworkReasons($language: String!) {
  listReworkReasons(language: $language) {
    key
    label
    rank
    current_status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListReworkReasonsGQL extends Apollo.Query<ListReworkReasonsQuery, ListReworkReasonsQueryVariables> {
    document = ListReworkReasonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetScanByIdDocument = gql`
    query GetScanById($id: ID!) {
  getScanById(id: $id) {
    id
    tenant_ref
    patient_id
    date
    user_id
    status
    device
    modality
    pixels_per_inch
    original_url_both
    original_url_left
    original_url_right
    dicom_url_both
    dicom_url_left
    dicom_url_right
    thumbnail_url_both
    thumbnail_url_left
    thumbnail_url_right
    toolstate_url_both
    toolstate_url_left
    toolstate_url_right
    cad_template_url_left
    cad_template_url_right
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetScanByIdGQL extends Apollo.Query<GetScanByIdQuery, GetScanByIdQueryVariables> {
    document = GetScanByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListScansByPatientIdDocument = gql`
    query ListScansByPatientId($patient_id: ID!, $limit: Int, $nextToken: String) {
  listScansByPatientId(
    patient_id: $patient_id
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant_ref
      patient_id
      date
      user_id
      status
      device
      modality
      pixels_per_inch
      original_url_both
      original_url_left
      original_url_right
      dicom_url_both
      dicom_url_left
      dicom_url_right
      thumbnail_url_both
      thumbnail_url_left
      thumbnail_url_right
      toolstate_url_both
      toolstate_url_left
      toolstate_url_right
      cad_template_url_left
      cad_template_url_right
    }
    nextToken
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListScansByPatientIdGQL extends Apollo.Query<ListScansByPatientIdQuery, ListScansByPatientIdQueryVariables> {
    document = ListScansByPatientIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListScansByOrderIdDocument = gql`
    query ListScansByOrderId($order_id: ID!) {
  listScansByOrderId_v2(order_id: $order_id) {
    id
    device
    date
    modality
    pixels_per_inch
    status
    original_url_both
    original_url_left
    original_url_right
    dicom_url_both
    dicom_url_left
    dicom_url_right
    thumbnail_url_both
    thumbnail_url_left
    thumbnail_url_right
    toolstate_url_both
    toolstate_url_left
    toolstate_url_right
    cad_template_url_left
    cad_template_url_right
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListScansByOrderIdGQL extends Apollo.Query<ListScansByOrderIdQuery, ListScansByOrderIdQueryVariables> {
    document = ListScansByOrderIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateScanDocument = gql`
    mutation CreateScan($input: CreateScanInput!) {
  createScan(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateScanGQL extends Apollo.Mutation<CreateScanMutation, CreateScanMutationVariables> {
    document = CreateScanDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateScanDocument = gql`
    mutation UpdateScan($input: UpdateScanInput!) {
  updateScan(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateScanGQL extends Apollo.Mutation<UpdateScanMutation, UpdateScanMutationVariables> {
    document = UpdateScanDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReplaceScanOutputsDocument = gql`
    mutation ReplaceScanOutputs($input: ReplaceScanOutputsInput!) {
  replaceScanOutputs(input: $input) {
    scans {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReplaceScanOutputsGQL extends Apollo.Mutation<ReplaceScanOutputsMutation, ReplaceScanOutputsMutationVariables> {
    document = ReplaceScanOutputsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUploadFilePresignedUrlDocument = gql`
    mutation CreateUploadFilePresignedUrl($tenant_ref: ID!, $filename: String!, $contentType: String!) {
  createUploadFilePresignedUrl(
    tenant_ref: $tenant_ref
    filename: $filename
    contentType: $contentType
  ) {
    bucket
    key
    url
    expiresIn
    method
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUploadFilePresignedUrlGQL extends Apollo.Mutation<CreateUploadFilePresignedUrlMutation, CreateUploadFilePresignedUrlMutationVariables> {
    document = CreateUploadFilePresignedUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDownloadFilePresignedUrlDocument = gql`
    mutation CreateDownloadFilePresignedUrl($key: String!) {
  createDownloadFilePresignedUrl(key: $key) {
    bucket
    key
    url
    expiresIn
    method
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDownloadFilePresignedUrlGQL extends Apollo.Mutation<CreateDownloadFilePresignedUrlMutation, CreateDownloadFilePresignedUrlMutationVariables> {
    document = CreateDownloadFilePresignedUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteScanDocument = gql`
    mutation DeleteScan($scan: DeleteScanInput!) {
  deleteScan(scan: $scan) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteScanGQL extends Apollo.Mutation<DeleteScanMutation, DeleteScanMutationVariables> {
    document = DeleteScanDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListTenantsDocument = gql`
    query ListTenants {
  listTenants {
    id
    name
    parent_id
    profile
    tenant_ref
    does_own_modelling
    workshop_milling_tenant_id
    workshop_milling_tenant_ref
    workshop_milling_tenant_name
    workshop_printing_tenant_id
    workshop_printing_tenant_ref
    workshop_printing_tenant_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListTenantsGQL extends Apollo.Query<ListTenantsQuery, ListTenantsQueryVariables> {
    document = ListTenantsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListWorkshopTenantsDocument = gql`
    query ListWorkshopTenants {
  listWorkshopTenants {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListWorkshopTenantsGQL extends Apollo.Query<ListWorkshopTenantsQuery, ListWorkshopTenantsQueryVariables> {
    document = ListWorkshopTenantsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListTenantParentsDocument = gql`
    query ListTenantParents {
  listTenantParents {
    id
    name
    parent_id
    profile
    tenant_ref
    does_own_modelling
    workshop_milling_tenant_id
    workshop_milling_tenant_ref
    workshop_milling_tenant_name
    workshop_printing_tenant_id
    workshop_printing_tenant_ref
    workshop_printing_tenant_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListTenantParentsGQL extends Apollo.Query<ListTenantParentsQuery, ListTenantParentsQueryVariables> {
    document = ListTenantParentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListTenantsByWorkshopTenantIdDocument = gql`
    query ListTenantsByWorkshopTenantId($workshop_tenant_id: ID!) {
  listTenantsByWorkshopTenantId(workshop_tenant_id: $workshop_tenant_id) {
    city
    country
    does_own_modelling
    house_number
    id
    name
    postal_code
    profile
    street
    tenant_ref
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListTenantsByWorkshopTenantIdGQL extends Apollo.Query<ListTenantsByWorkshopTenantIdQuery, ListTenantsByWorkshopTenantIdQueryVariables> {
    document = ListTenantsByWorkshopTenantIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTenantDocument = gql`
    mutation CreateTenant($input: CreateTenantInput!) {
  createTenant(input: $input) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTenantGQL extends Apollo.Mutation<CreateTenantMutation, CreateTenantMutationVariables> {
    document = CreateTenantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    success
    message
    username
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    document = CreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }